import { BusinessLine, BusinessLineVal, Control, FormChangeRequestType } from './../../../classes/dynamic-form/dynamic-form.class';
import { ACCOUNT_CONTACT_AFFILIATIONS_REF_ENTITY, OUTSIDE_TERRITORY_ROW_KEY } from './../../../config/dynamic-forms/affiliations-contants';
import {takeUntil} from 'rxjs/operators';
import {ChangeDetectorRef, Component, ElementRef, ViewChild, Input, HostListener} from '@angular/core';
import {ContactOfflineService} from '../../../services/contact/contact.service';
import {ComponentViewMode, UIService} from '../../../services/ui/ui.service';
import {DeviceService} from '../../../services/device/device.service';
import {NavController, LoadingController, ModalController, PopoverController, NavParams} from '@ionic/angular';
import {InAppBrowser} from '@awesome-cordova-plugins/in-app-browser/ngx';
import {AuthenticationService} from '../../../services/authentication.service';
import {FeatureActionsMap, IoConfigurationFeatureCodes} from '../../../classes/authentication/user.class';
import {TranslateService} from '@ngx-translate/core';
import { DateTimeFormatsService } from '../../../services/date-time-formats/date-time-formats.service';
import {BusinessProcessType, ControlDataType, DynamicForm, FormType, OmniGender, OneCRMGender, OneCRMReqType, DCR_CATEGORY, DCR_SOURCE} from '../../../classes/dynamic-form/dynamic-form.class';
import {DynamicFormsService} from '../../../services/dynamic-forms/dynamic-forms-service';
import {DynamicFormComponentModel, DynamicFormType} from '../../../models/dynamic-form-component.model';
import {GlobalUtilityService} from '../../../services/global-utility.service';
import {NavigationService, PageName} from '../../../services/navigation/navigation.service';
import {MedProSearchService} from '../../../services/medpro/medpro-search.service';
import {MedProSearchMode, MedProFilter, MedProFilterFieldKey} from '../../../data-services/medpro/medpro.models';
import {MEDPRO_DESIGNATIONS} from '../../../data-services/medpro/medpro-filter-fields';
import {CustomerLicense, CUSTOMER_LICENSE_TYPE} from '../../../classes/sampling/customer-license.class';
import {StatusCode} from '../../../enums/shared-enums';
import {SampleService} from '../../../services/sample/sample.service';
import {ContactDataService} from '../../../data-services/contact/contact.data.service';
import {NotificationService, ToastStyle} from '../../../services/notification/notification.service';
import {AlertService} from '../../../services/alert/alert.service';
import {NothingSelectedView} from '../../shared/nothing-selected-view/nothing-selected-view';
import {
  DEFAULT_CONTACT_CREATE_FORM,
  DEFAULT_CONTACT_DISPLAY_FORM,
  TAG_LABEL_CONTROL,
} from '../../../config/dynamic-forms/default-contact/default-contact-create';
import { TrackService, TrackingEventNames } from '../../../services/logging/tracking.service';
import { EventsService } from '../../../services/events/events.service';
import { Subject, Observable } from 'rxjs';
import { IndSectionHeaderViewDataModel } from '../../../models/indSectionHeaderDataModel';
import { IONote } from '../../../classes/io/io-note.class';
import { DB_KEY_PREFIXES } from '../../../config/pouch-db.config';
import { DiskService, OFFLINE_DB_LINKED_ENTITY_NAME } from '../../../services/disk/disk.service';
import {MDMRequestType, MDMType, ChangeRequestType, ChangeRequestStatusCode, ChangeRequestStateCode} from '@omni/classes/mdm/source-type-optionset.class';
import {MdmService} from "@omni/services/mdm/mdm.service";
import { FooterService, FooterViews } from '@omni/services/footer/footer.service';
import { AccountOfflineService } from '@omni/services/account/account.offline.service';
import { ActivitySource } from '@omni/services/activity/activity.service';
import { NewActivityDataModel } from '@omni/models/indNewActivityDataModel';
import { MAXIMUM_NOTE_ATTACHMENT_SIZE, NOTE_ATTACHMENT_MIME_TYPES_SUPPORTED_REGEX, toBase64 } from '@omni/utility/util';
import { MyAssistantService, NOTIFICATION } from '@omni/services/my-assistant/my-assistant.service';
import { IntegrationType } from '@omni/classes/onekey/ok-integration.class';
import { VeevaWidgetService } from '@omni/services/veeva-widget/veeva-widget.service';
import { DynamicsClientService } from '@omni/data-services/dynamics-client/dynamics-client.service';
import { KOLStatus, KOLStatusCode } from '@omni/classes/contact/kol-status.class';
import { ContactMedicalInsight, MedicalInsightCategory, PdrpOptOutStatus, TargetLevel, ContactAddress } from '@omni/classes/contact/contact.class';
import { ContactMedicalInsightComponent } from '../contact-medical-insight/contact-medical-insight';
import { IndFormFieldViewDataModel } from '@omni/models/indFormFieldDataModel';
import { DatePipe } from '@angular/common';
import { TerritoryManagementService } from '@omni/services/territory-management/territory-management.service';
import { cloneDeep, isEmpty, isEqual, sortBy } from 'lodash-es';
export class ContactModel {
	id: string;
	name: string;
}

/**
 * Generated class for the ContactInfoComponent component.
 *
 * See https://angular.io/api/core/Component for more info on Angular
 * Components.
 */
// OnPush deferred — reads contactService, authService, uiService, mdmService, etc. directly in template
@Component({
  selector: 'contact-info',
  templateUrl: 'contact-info.html',
  styleUrls:['contact-info.scss']
})
export class ContactInfoComponent {

  public isEditable: boolean = false;
  public compViewMode = ComponentViewMode;
  //public configuredFields:ConfiguredFields[]=[];
  public isEditFeatureEnabled:boolean = false;
  public mdmEditFeatureEnabled:boolean = false;
  public businessEditFeatureEnabled:boolean = false;
  public changeRequestCategoryFlowFeatureEnabled:boolean = false;
  private selectedChangeRequestCategoryId: string = null;
  private selectedChangeRequestCategoryName: string = null;
  private currentChangeRequestFormId: string = null;
  private currentChangeRequestCategoryForm: DynamicForm = null;
  public isEditCustomerForEventEnabled:boolean = false;
  public isCustomerNotesEnabled:boolean = false;
  public isCustomerNotesAttachmentEnabled = false;
  private unsubscribe$ = new Subject<void>();
  private isPreViewMode: boolean = false;

  public displayFormDetails;
  public rawFormData;
  public dynamicFormType:DynamicFormType;

  public notesSectionHeaderViewData:IndSectionHeaderViewDataModel;
  //public medicalInsightsSectionHeaderViewData:IndSectionHeaderViewDataModel;
  public tempNoteText: string = '';
  public notesPlaceholder:string = '';
  public isSaveNotesEnabled:boolean = false;
  public currentCustomerNotes:Array<IONote> = [];
  public currentMedicalInsights:Array<ContactMedicalInsight> = [];
  public isEditDisabled:boolean;
  public isInputDisabled: boolean = false;
  @ViewChild('scrollTop', { read: ElementRef, static: false }) scrollTop;
  //  tooltipEvent : string;
  //  tooltipDuration = 1000;
  @Input() scrollObservable: Observable<any>;
  private linkEntitiesReqPayload: any = [];
  @Input()
  public accessedFrom: string;

  @ViewChild('attachInput') attachInput: ElementRef;
  public attachmentTitle: string = '';
  public isAttachmentAdded: boolean = false;
  private attachmentFile: any;
  private base64str;
  public customerNotes: Array<IONote> = [];
  public kolStatusSectionHeaderViewData:IndSectionHeaderViewDataModel;
  public contactKOLStatuses: Array<KOLStatus> = [];
  private businessLine;
  @Input() enableEditBtn: boolean = false;
  public extraHeaderControls: Array<{ id: string; text: string; isDisabled: boolean }> = [];

  private hideEmailAddressInformationOption: boolean = false;
  private hideBusinessInformationOption: boolean = false;

  constructor(
    public contactService: ContactOfflineService,
    private accountService: AccountOfflineService,
    public authService: AuthenticationService,
    private device: DeviceService,
    private translate: TranslateService,
    private dynamicFormsService: DynamicFormsService,
    private utilityService: GlobalUtilityService,
    private navService: NavigationService,
    private loadingCtrl: LoadingController,
    private contactDataService: ContactDataService,
    private notificationService: NotificationService,
    private alertService: AlertService,
    public uiService: UIService,
    private trackingService: TrackService,
    private events: EventsService,
    public popoverCtrl: PopoverController,
    private disk: DiskService,
    private modalCtrl: ModalController,
    public mdmService: MdmService,
    private footerService:FooterService,
    private iab: InAppBrowser,
    private veevaWidgetService: VeevaWidgetService,
    private dynamics: DynamicsClientService,
    private readonly dateTimeFormatsService: DateTimeFormatsService,
    private readonly datePipe: DatePipe,
    private navParams: NavParams,
    private readonly territoryService: TerritoryManagementService,
    public myAssistantService: MyAssistantService,
    private readonly _cd: ChangeDetectorRef,
    private readonly medProSearchSvc: MedProSearchService,
    private readonly sampleService: SampleService,
  ) {
      // if(this.authService.hasFeatureAction(FeatureActionsMap.MEDICAL_PROFILE)){
      //   this.isMedProfileEnabled = true;
      // }
      this.events.observe('active-consent').pipe(takeUntil(this.unsubscribe$)).subscribe((val:boolean)=> {
        this.enableEditBtn = val;
        this.initFeatureActions();
      });

      this.contactService.contactInformationObservable.pipe(takeUntil(this.unsubscribe$)).subscribe(()=> {
        this.initFeatureActions();
        this.initContactInfo();
        //this._initMedicalInsightsViewData();
        this._cd.markForCheck();
      })

      // Re-evaluate header controls (mainly the Revalidate button's
      // isDisabled flag) whenever offline state flips. Without this the
      // button would still be enabled if the rep was online when they
      // opened the contact and then lost connectivity.
      this.device.isOfflineObservable.pipe(takeUntil(this.unsubscribe$)).subscribe(() => {
        this.initFeatureActions();
        this._cd.markForCheck();
      });
    this.contactService.selectedOKContactObserver.pipe(takeUntil(this.unsubscribe$)).subscribe(() => {
      this.initOKContactInfo();
    });

    // this.contactService.newMedicalInsightObservable.pipe(takeUntil(this.unsubscribe$)).subscribe(async (medicalInsight:ContactMedicalInsight)=> {
    //   if(medicalInsight){
    //     this._handledNewMedicalInsightCreation(medicalInsight);
    //   }
    // });

    switch (this.utilityService.globalCustomerText) {
      case 'Customer':
        break;
      case 'Stakeholder':
        break;
      default:
        break;
    }
  }

  ngOnInit(){
    this.initFeatureActions();
    this.initIoConfiguration();
    this.initContactInfo();
    this.contactService.contactNotesUpdated.pipe(takeUntil(this.unsubscribe$)).subscribe(async () => {
      await this.initCustomerNotesData();
      this._cd.markForCheck();
    });
    this.contactService.contactUpdated.pipe(takeUntil(this.unsubscribe$)).subscribe(() => {
      this.initFeatureActions();
      this.initCustomerNotesData();
      this.initKOLStatusViewData();
      //this._initMedicalInsightsData();
      this.initFeatureActions();
      this.initIoConfiguration();
      this._cd.markForCheck();
    });
  }

  initFeatureActions() {
    this.businessLine = this.authService.user?.buConfigs?.indskr_businessline;
    this.mdmEditFeatureEnabled = this.contactService.contactInformation && this.authService.hasFeatureAction(FeatureActionsMap.CONTACTS_EDIT_REQUEST)
      && (this.contactService.contactInformation.mdmType === MDMType.ONEKEY || this.enableEditBtn);
    this.businessEditFeatureEnabled = this.authService.hasFeatureAction(FeatureActionsMap.CONTACT_EDITOR);
    this.changeRequestCategoryFlowFeatureEnabled = this.authService.hasFeatureAction(FeatureActionsMap.CONTACT_CHANGE_REQUEST_CATEGORY_FLOW);
    this.isEditFeatureEnabled = this.businessEditFeatureEnabled || this.mdmEditFeatureEnabled || this.changeRequestCategoryFlowFeatureEnabled;
    this.isEditCustomerForEventEnabled = (this.authService.user.featureActions.indexOf(FeatureActionsMap.CONTACT_EDITOR_EVENTS) > -1);
    this.isCustomerNotesEnabled = this.authService.hasFeatureAction(FeatureActionsMap.CUSTOMER_NOTES);
    //this.footerService.updateButtons([], true);
    this.isCustomerNotesAttachmentEnabled = this.authService.hasFeatureAction(FeatureActionsMap.CUSTOMER_NOTES_ATTACHMENT_UPLOAD)
    const isContactfromContactToolEditable = this.isEditFeatureEnabled
      && ((!this.contactService.isInGlobalSearch || !this.contactService.isContactInGlobalSearch(this.contactService.contactInformation)) || this.businessLine === BusinessLineVal.PHARMA || this.businessLine === BusinessLineVal.RETAIL || this.businessLine === BusinessLineVal.VACCINE_MDM)
      && (this.contactService.contactPageMode === this.compViewMode.LISTVIEW || this.contactService.contactPageMode === this.compViewMode.ADDNEW)
      && !this.uiService.isConsentFromToolDrawer;
    const isContactfromEventsToolEditable = this.isEditCustomerForEventEnabled && (!this.contactService.isInGlobalSearch || !this.contactService.isContactInGlobalSearch(this.contactService.contactInformation)) && this.contactService.contactPageMode===this.compViewMode.ADDNEW && !this.uiService.isConsentFromToolDrawer;

    if (this.contactService.accessedContactListFrom === PageName.EventDetailsPageComponent) {
      this.isEditable = isContactfromEventsToolEditable;
    } else {
      this.isEditable = isContactfromContactToolEditable;
    }
    if (this.contactService.contactPageMode === ComponentViewMode.PREVIEW || this.contactService.isContactInGlobalSearch(this.contactService.contactInformation)) {
      this.isPreViewMode = true;
      this.isEditable = false;
      this.isEditDisabled = true;
    } else {
      this.isPreViewMode = false;
      this.isEditable = isContactfromContactToolEditable;
      this.isEditDisabled = false;
    }
    // Disable (greyed-out, not hidden) rather than hiding the button outright when offline -
    // matches configured-account-info.ts's equivalent offline gate for the Edit button on the
    // Account display form. This must run after the preview-mode if/else above, which
    // unconditionally resets isEditDisabled - setting isEditable=false here instead (as this
    // block previously did) got silently undone by that reset in the common non-preview case.
    if (this.device.isOffline && this.isEditable && this.contactService.contactInformation && (this.contactService.contactInformation.mdmType == MDMType.VEEVA || this.changeRequestCategoryFlowFeatureEnabled || this.mdmEditFeatureEnabled)) {
      this.isEditDisabled = true;
      // this.veevaWidgetService.loadVeevaScripts();
    }
    // Show the Revalidate control whenever the contact + feature action are
    // present; disable (greyed-out, not hidden) when offline. Revalidation
    // calls into MedPro Universe over HTTP — it can't run without
    // connectivity — but yanking the button on connection drop is jarring
    // for the rep, so we keep it visible and just disable it.
    const medProAvailable = !!this.contactService.contactInformation
      && this.authService.hasFeatureAction(FeatureActionsMap.CONTACTS_MEDPRO_SEARCH);
    this.extraHeaderControls = medProAvailable
      ? [{
          id: ContactInfoComponent.UPDATE_FROM_MEDPRO_CONTROL_ID,
          text: this.translate.instant('UPDATE_FROM_MEDPRO'),
          isDisabled: this.device.isOffline,
        }]
      : [];
  }

  private initIoConfiguration() {
    this.hideEmailAddressInformationOption = this.authService.hasIoConfigWithFeatureCode(IoConfigurationFeatureCodes.BU_CONTACT_GA_HIDE_EMAIL_ADDRESS_INFORMATION_OPTION) as boolean;
    this.hideBusinessInformationOption = this.authService.hasIoConfigWithFeatureCode(IoConfigurationFeatureCodes.BU_CONTACT_GA_HIDE_BUSINESS_INFORMATION_OPTION) as boolean;
  }

  private addRemovedPositionLinkEntity(payload: any, positionId: string): void {
    const existingLinkEntities = payload["linkEntities"] || [];
    const customerPositionLinkEntityIndex = existingLinkEntities.findIndex(le => le.entity === 'exe_customerpositionchangerequests');

    const removedPositionLinkEntity = {
      "entity": "exe_customerpositionchangerequests",
      "values": [
        {
          "lookupfields": [
            {
              "name": "exe_Position_New",
              "entity": "positions",
              "id": positionId
            },
            {
              "name": "exe_ContactChangeRequest",
              "entity": "indskr_contactcrs"
            }
          ],
          "exe_type": 791060002
        }
      ]
    };

    if (customerPositionLinkEntityIndex >= 0) {
      const existingValues = existingLinkEntities[customerPositionLinkEntityIndex].values || [];
      const removedPositionExists = existingValues.some(val =>
        val.lookupfields?.some(lf => lf.name === "exe_Position_New" && lf.id === positionId)
      );
      if (!removedPositionExists) {
        existingLinkEntities[customerPositionLinkEntityIndex].values.push(removedPositionLinkEntity.values[0]);
      }
    } else {
      existingLinkEntities.push(removedPositionLinkEntity);
    }
    payload["linkEntities"] = existingLinkEntities;
  }

  ngOnDestroy() {
    this.unsubscribe$.next();
    this.unsubscribe$.complete();
  }

  trackById(index: number, item: any) { return item?.id || item?.ID || index; }

  ngAfterViewInit(){
    if (this.contactService.isOneKeySearching) {
      this.initOKContactInfo();
    } else {
      this.initContactInfo();
    }
    if(this.scrollTop) this.scrollTop.nativeElement.scrollIntoView(false);
  }

  private _initCustomerNotesViewData(){

     if (this.isCustomerNotesEnabled || this.isCustomerNotesAttachmentEnabled) {
      let controls: any[] = [];
      if (this.isCustomerNotesAttachmentEnabled) {
        controls.push({
          id:'attach_note',
          text: this.translate.instant('ATTACH'),
          isDisabled: this.isPreViewMode,
        });
      }
      controls.push({
        id: 'save_note',
        text: this.translate.instant('SAVE'),
        isDisabled: isEmpty(this.tempNoteText) && !this.isAttachmentAdded || this.isPreViewMode,
      });
      this.notesSectionHeaderViewData = {
        id: 'contact_notes_section_header',
        title: this.translate.instant('CUSTOMER_NOTES_CAP'),
        controls: controls
      };
      let isNotesOnBU = this.authService.user.buConfigs["indskr_notessectionhelptext"];
      this.notesPlaceholder = isNotesOnBU? isNotesOnBU : this.translate.instant('ENTER_NOTES');
    }
  }

  public onSectionHeaderControlClick(id:string){
    switch(id){
      case 'save_note':
        this.handleSaveNote();
        break;
      case 'attach_note':
        this.handleNoteAttachment();
        break;
      default:
        break;
    }
  }

  private async initCustomerNotesData(){
    // Built aside and swapped in whole: clearing first leaves an empty list across the awaits, where an
    // edit/delete lookup by id fails and is dropped.
    const notes: IONote[] = [];

    let dbNotes = await this.disk.retrieve(OFFLINE_DB_LINKED_ENTITY_NAME.CONTACT_NOTES);
    if(dbNotes && dbNotes.raw && Array.isArray(dbNotes.raw) && dbNotes.raw.length != 0){
      dbNotes.raw.forEach(item=>{
        if(this.contactService.contactInformation &&
        item['annotation.objectid'] == this.contactService.contactInformation.ID &&
        item['annotation.annotationid'] &&
        item['annotation.ownerid'] &&
        item['annotation.createdon']){
          const payload = {
            annotationid: item['annotation.annotationid'],
            contactid: item['annotation.objectid'],
            createdon: item['annotation.createdon'] ? new Date(item['annotation.createdon']).getTime().toString() : null,
            notetext: item['annotation.notetext'],
            ownerName: item['annotation.ownerid@OData.Community.Display.V1.FormattedValue'],
            ownerid: item['annotation.ownerid'],
            filename: item['annotation.filename'],
            filesize: item['annotation.filesize'],
            isdocument: !isEmpty(item['annotation.filename']),
            mimetype: item['annotation.mimetype']
          };
          let currentNote = new IONote(payload);
          let idx = notes.findIndex(note => note.noteId == currentNote.noteId);
          if(idx >= 0){
            notes[idx] = currentNote;
          }else{
            notes.push(currentNote);
          }
        }
      });
    }
    let offlineNotes = await this.disk.retrieve(DB_KEY_PREFIXES.OFFLINE_CUSTOMER_NOTES);
    if(offlineNotes && offlineNotes.raw && Array.isArray(offlineNotes.raw) && offlineNotes.raw.length != 0){
      offlineNotes.raw.forEach(item => {
        if(item && item.deleted){
          let idx = notes.findIndex(note => note.noteId == item.annotationid);
          if(idx >= 0){
            notes.splice(idx,1);
          }
        }else if(this.contactService.contactInformation && item.contactid == this.contactService.contactInformation.ID){
          let currentNote = new IONote(item);
          let idx = notes.findIndex(note => note.noteId == currentNote.noteId);
          if (idx >= 0) {
            notes[idx] = currentNote;
          } else {
            notes.push(currentNote);
          }
        }
      });
    }
    this.currentCustomerNotes = notes;
    this._sortCustomerNotes();
  }

  private async initKOLStatusViewData(){
    if(this.authService.hasFeatureAction(FeatureActionsMap.CUSTOMER_KOL_STATUS)){
      let offlineData = await this.disk.retrieve("indskr_kolstatus");
      if(offlineData && offlineData.raw && Array.isArray(offlineData.raw)){
        this.contactKOLStatuses = [];
        offlineData.raw.forEach(item => {
          if(item['indskr_kolstatus.statuscode'] == KOLStatusCode.Approved && item['indskr_kolstatus.indskr_customer'] == this.contactService.contactInformation.ID){
            let kol = new KOLStatus(
              {
                "indskr_kolstatusid": item['indskr_kolstatus.indskr_kolstatusid'],
                "indskr_name": item['indskr_kolstatus.indskr_name'],
                "indskr_koltype_Formatted": item['indskr_kolstatus.indskr_koltype_Formatted'],
                "indskr_koltype": item['indskr_kolstatus.indskr_koltype'],
                "_indskr_therapeuticarea_value": item['indskr_kolstatus.indskr_therapeuticarea'],
                "_indskr_therapeuticarea_value_Formatted": item['indskr_kolstatus.indskr_therapeuticarea_Formatted'],
                "_indskr_specialty_value": item['indskr_kolstatus.indskr_specialty'],
                "_indskr_specialty_value_Formatted": item['indskr_kolstatus.indskr_specialty_Formatted'],
                "_indskr_diseasearea_value": item['indskr_kolstatus.indskr_diseasearea'],
                "_indskr_diseasearea_value_Formatted": item['indskr_kolstatus.indskr_diseasearea_Formatted'],
                "indskr_comments": item['indskr_kolstatus.indskr_comments'],
                "_ownerid_value": item['indskr_kolstatus.ownerid'],
                "_indskr_customer_value_Formatted": item['indskr_kolstatus.indskr_customer_Formatted'],
                "_indskr_customer_value": item['indskr_kolstatus.indskr_customer'],
                "_ownerid_value_Formatted": item['indskr_kolstatus.ownerid_Formatted'],
                "createdon": item['indskr_kolstatus.createdon'],
                "statuscode": item['indskr_kolstatus.statuscode'],
                "statuscode_Formatted": item['indskr_kolstatus.statuscode_Formatted'],
                "statecode": item['indskr_kolstatus.statecode'],
                "aa.indskr_approvalactivityid": '',
                "aa.statuscode_Formatted": '',
                "isPendingPushToDynamics": false,
                "isApprovalRecord": false,
              }
            );
            this.contactKOLStatuses.push(kol);
          }
        });
        this.contactKOLStatuses.sort((a,b)=> a.createdOn.getTime() - b.createdOn.getTime());
      }
      this.kolStatusSectionHeaderViewData = {
        id: 'contact_kol_statuses_section_header',
        title: this.translate.instant('KOL_STATUS'),
        controls: []
      };
    }
  }

  public notesChanged(ev): void {
    if(ev && ev.target){
      this.tempNoteText = ev.target.value;
    }else{
      this.tempNoteText = '';
    }
    if(this.tempNoteText.length > 0){
      this.isSaveNotesEnabled = true;
    }else{
      this.isSaveNotesEnabled = false;
    }
    this._initCustomerNotesViewData();
  }

  @HostListener('window:veeva-network-dcr-submitted', ['$event'])
  async dcrSubmitted(event) {
    if (this.contactService.contactInformation.ID && event.detail.taskId) {
      await this.dynamics.dwa.create({
        omniveev_externalid: event.detail.taskId,
        omniveev_type: 200000001,
        'omniveev_customer_contact@odata.bind': `/contacts(${this.contactService.contactInformation.ID})`
      }, "omniveev_datachangerequests");
    }
  }

  static readonly UPDATE_FROM_MEDPRO_CONTROL_ID = 'UPDATE_FROM_MEDPRO';

  get isUpdateFromMedProEnabled(): boolean {
    if (this.device.isOffline) return false;
    if (!this.contactService.contactInformation) return false;
    return this.authService.hasFeatureAction(FeatureActionsMap.CONTACTS_MEDPRO_SEARCH);
  }


  onExtraHeaderControlClick(id: string) {
    if (id === ContactInfoComponent.UPDATE_FROM_MEDPRO_CONTROL_ID) {
      this.updateFromMedPro();
    }
  }

  async updateFromMedPro(): Promise<void> {
    if (!this.contactService.contactInformation) return;
    const contactId = this.contactService.contactInformation.ID;
    const raw = this.rawFormData || {};

    const confirmed = await this.alertService.showAlert(
      {
        title: this.translate.instant('MEDPRO_CONFIRM_REVALIDATE_TITLE'),
        message: this.translate.instant('MEDPRO_CONFIRM_REVALIDATE_MSG'),
      },
      this.translate.instant('CONFIRM'),
      this.translate.instant('CANCEL'),
    ).then(res => res.role === 'ok').catch(() => false);
    if (!confirmed) return;

    // Ask the server first — it owns the matching strategy (master ID →
    // NPI → DEA today). refreshContactFromMedpro also refetches the single
    // contact on success, firing contactInformationObservable so this
    // component re-renders with the fresh data. Only fall back to the
    // manual picker if the server reports not-found.
    const loader = await this.loadingCtrl.create();
    await loader.present();
    try {
      const result = await this.medProSearchSvc.refreshContactFromMedpro(contactId);
      if (result.ok === true) {
        // Suppress the success toast when the user navigated away mid-flight
        // (OMNI-59618). The master cache + contactUpdated emit already kept
        // the originating row consistent in the background; firing a toast
        // on whatever the rep is now looking at would be misleading.
        if (!result.contextChanged) {
          this.notificationService.notify(
            this.translate.instant('MEDPRO_UPDATE_SUCCESS'),
            'ContactInfoComponent', 'top', ToastStyle.INFO, 3000, true,
          );
        }
        return;
      }
      if (result.fallback === 'not-found') {
        // Inform the rep WHY the page is changing — without this toast the
        // redirect to the MedPro picker looks like a random nav. The toast
        // also nudges them toward the right next step (refine + pick HCP).
        this.notificationService.notify(
          this.translate.instant('MEDPRO_REVALIDATE_REFINE_SEARCH'),
          'ContactInfoComponent', 'top', ToastStyle.INFO, 4000, true,
        );
        await this.openMedProSearchFallback(contactId, raw);
        return;
      }
      if (result.fallback === 'network-lost') {
        this.notificationService.notify(
          this.translate.instant('MEDPRO_NETWORK_UNSTABLE'),
          'ContactInfoComponent', 'top', ToastStyle.DANGER, 5000, true,
        );
        return;
      }
      this.notificationService.notify(
        result.errorMessage,
        'ContactInfoComponent', 'top', ToastStyle.DANGER, 5000, true,
      );
    } catch (err: any) {
      this.notificationService.notify(
        (err && (err.message || err.Message)) || 'MedPro update failed',
        'ContactInfoComponent', 'top', ToastStyle.DANGER, 5000, true,
      );
    } finally {
      await loader.dismiss();
    }
  }

  private async openMedProSearchFallback(contactId: string, raw: any): Promise<void> {
    const contact = this.contactService.contactInformation;
    const licenses = this.getActiveLicensesFor(contactId);
    // contactInformation.addressesList isn't reliably populated in the
    // revalidate->fallback path. Fall back to the offline ADDRESSES store. We only
    // need each address's lu_state GUID (stateId) here; the 2-letter code is
    // resolved on demand below.
    const addresses: ContactAddress[] = contact?.addressesList?.length
      ? contact.addressesList
      : await this.contactService.loadContactAddressesFromDB(contactId);

    // Superset seeding: extract every field the contact can populate. The
    // MedPro search page filters by configuredFieldKeys, so seed entries
    // for fields not configured for this tenant are silently ignored at
    // render time. Empty values are dropped so an empty seed doesn't trip
    // the per-field length validators when the rep clicks Search.
    //
    // Skip-when-ambiguous rule on license/designation-derived fields: if
    // the contact has multiple active state licenses or a non-MedPro
    // designation, we leave the field blank rather than seed the wrong
    // value. The rep can still add the field manually in the picker.
    const seedFilters: MedProFilter[] = [];
    const push = (field: MedProFilterFieldKey, value: any) => {
      const v = (value ?? '').toString().trim();
      if (v) seedFilters.push({ field, value: v });
    };
    push('firstName',   raw.firstname);
    push('lastName',    raw.lastname);
    push('middleName',  raw.middlename);
    push('npi',         raw.indskr_npi_number);
    // The State (SLN) + State filters need the real 2-letter lu_state code. Synced
    // data only carries the state NAME (the configured-form sync can't reach the
    // 2-level-nested lu_state.indskr_statecode), so resolve the code on demand from
    // the lu_state GUIDs the license/address already hold — one fetch, both fields.
    // This flow is online (it just called MedPro), so the extra fetch is fine.
    const stateLicenses = licenses.filter(l => l.licenseType === CUSTOMER_LICENSE_TYPE.State);
    const singleStateLicense = stateLicenses.length === 1 ? stateLicenses[0] : null;
    const primaryAddress = addresses.find(a => a?.isPrimary) ?? addresses[0];
    const stateCodeByLuId = await this.contactService.getStateCodesByLuStateIds([
      singleStateLicense?.stateId,
      primaryAddress?.stateId,
    ]);
    const toTwoLetterCode = (luStateId?: string): string | null => {
      let code = (stateCodeByLuId.get(luStateId) ?? '').trim().toUpperCase();
      // Some lu_state codes are region-prefixed (e.g. "US-OH"); take the last segment.
      if (code.includes('-')) code = (code.split('-').pop() || '').trim();
      return /^[A-Z]{2}$/.test(code) ? code : null;
    };
    // License state ("State (SLN)") only when the contact has exactly one active
    // state license, to avoid seeding the wrong one for multi-state HCPs.
    push('state',        singleStateLicense ? toTwoLetterCode(singleStateLicense.stateId) : null);
    push('addressState', toTwoLetterCode(primaryAddress?.stateId));
    push('sln',         this.deriveSlnSeed(licenses));
    push('dea',         this.deriveDeaSeed(licenses));
    push('designation', this.deriveDesignationSeed(contact));

    const mode: MedProSearchMode = {
      kind: 'from-contact',
      contactId,
      seedFilters,
      // All seeds are prefills only — rep can edit, swap the field, or
      // remove any row.
      lockedFieldKeys: [],
    };
    // No callback needed — MedProSearchService.refreshContactFromMedpro
    // internally refetches the contact, which fires contactInformationObservable
    // and this component re-renders.
    this.navService.pushChildNavPageWithPageTracking(
      PageName.MedProSearchPageComponent,
      PageName.MedProSearchPageComponent,
      PageName.ContactPageComponent,
      { mode },
    );
  }

  private getActiveLicensesFor(contactId: string): CustomerLicense[] {
    return (this.sampleService.customerLicenses || []).filter(
      l => l.contactId === contactId && l.statusCode === StatusCode.Active,
    );
  }

  /** SLN: seed only when the contact has exactly one active state license.
   *  Multiple licenses → skip (rep adds manually) to avoid sending the
   *  wrong one when the HCP holds multi-state licenses. */
  private deriveSlnSeed(licenses: CustomerLicense[]): string | null {
    const stateLicenses = licenses.filter(l => l.licenseType === CUSTOMER_LICENSE_TYPE.State);
    if (stateLicenses.length !== 1) return null;
    return ((stateLicenses[0].licenseNumber ?? '') as string).trim() || null;
  }

  /** DEA: same skip-when-ambiguous rule as SLN. */
  private deriveDeaSeed(licenses: CustomerLicense[]): string | null {
    const deaLicenses = licenses.filter(l => l.licenseType === CUSTOMER_LICENSE_TYPE.DEA);
    if (deaLicenses.length !== 1) return null;
    return ((deaLicenses[0].licenseNumber ?? '') as string).trim() || null;
  }

  /** Designation seed: the contact's primary professional designation
   *  (MD, NURSE, etc.). Only seeded when it matches MedPro's known list
   *  — custom non-MedPro designations would just be dropped server-side
   *  and would only confuse the rep if prefilled. */
  private deriveDesignationSeed(contact: any): string | null {
    const code = ((contact?.professionalDesignation?.designation ?? '') as string)
      .trim().toUpperCase();
    if (!code) return null;
    return MEDPRO_DESIGNATIONS.includes(code) ? code : null;
  }

  async editContact(event){
    this.dynamicFormsService.okLookUpMapper = [];
    if (this.contactService.contactInformation.mdmType == MDMType.VEEVA) {
      await this.veevaWidgetService.openProfileWidget(
        this.contactService.contactInformation.appId,
        this.contactService.contactInformation.fullName);
      return;
    }

    if (this.contactService.contactInformation.mdmType == MDMType.ONEKEY) {
      this.accountService.isOneKeyChangeRequest = true;
      this.contactService.isOneKeyChangeRequest = true;
      if (this.businessEditFeatureEnabled && this.mdmEditFeatureEnabled) {
        const newActivityModel: NewActivityDataModel = {
          source: ActivitySource.ONE_KEY_CONTACT_EDIT,
          displayOptions: [
            {
              id: "business_information",
              formattedLabel: this.translate.instant('ONE_KEY_BUSINESS_CONTACT_EDIT_INFORMATION'),
              isChecked: true,
              isDisabled:false
            },
            {
              id: "one_key_information",
              formattedLabel: this.translate.instant('ONE_KEY_MDM_CONTACT_EDIT_INFORMATION'),
              isChecked: false,
              isDisabled:false
            }
          ],
          title: this.translate.instant('EDIT') + " " + this.contactService.contactInformation.fullName,
          eventHandler: this.makeEditOptionDispatcher((data) => this.handleSelectEvent(data))
        }

        if (!this.hideEmailAddressInformationOption) {
          newActivityModel.displayOptions.push({
            id: "business_cr_emailaddress_information",
            formattedLabel: this.translate.instant('EMAIL_ADDRESS_INFORMATION'),
            isChecked: false,
            isDisabled:false
          });
        }

        newActivityModel.displayOptions.push(...this.buildChangeRequestCategoryOptions());
        newActivityModel.displayOptions = this.applyEditMenuOptionConfig(newActivityModel.displayOptions);
        if (newActivityModel.displayOptions.length === 0) {
          this.notificationService.notify(this.translate.instant('NO_OPTIONS_AVAILABLE'), 'ContactInfoComponent', "top", ToastStyle.DANGER, 3000);
          return;
        }
        this.navService.pushChildNavPageWithPageTracking(PageName.NewChangeRequestComponent, PageName.NewChangeRequestComponent, PageName.ContactPageComponent, {newActivityDataModel : newActivityModel}).then(()=>{
          this.uiService.prevView = this.uiService.activeView;
          this.uiService.activeView = 'ContactPageRightPaneNav';
          this.uiService.showNewActivity = false;
        });
      } else if (this.businessEditFeatureEnabled){
        this.accountService.isOneKeyChangeRequest = false;
        this.contactService.isOneKeyChangeRequest = false;
        // this.oneKeyContactBusinessInformationEditFlow();
        const newActivityModel: NewActivityDataModel = {
          source: ActivitySource.ONE_KEY_CONTACT_EDIT,
          displayOptions: [
            {
              id: "business_information",
              formattedLabel: this.translate.instant('ONE_KEY_BUSINESS_CONTACT_EDIT_INFORMATION'),
              isChecked: true,
              isDisabled:false
            }
          ],
          title: this.translate.instant('EDIT') + " " + this.contactService.contactInformation.fullName,
          eventHandler: this.makeEditOptionDispatcher((data) => this.handleSelectEvent(data))
        }

        if (!this.hideEmailAddressInformationOption) {
          newActivityModel.displayOptions.push({
            id: "business_cr_emailaddress_information",
            formattedLabel: this.translate.instant('EMAIL_ADDRESS_INFORMATION'),
            isChecked: false,
            isDisabled:false
          });
        }

        newActivityModel.displayOptions.push(...this.buildChangeRequestCategoryOptions());
        newActivityModel.displayOptions = this.applyEditMenuOptionConfig(newActivityModel.displayOptions);
        if (newActivityModel.displayOptions.length === 0) {
          this.notificationService.notify(this.translate.instant('NO_OPTIONS_AVAILABLE'), 'ContactInfoComponent', "top", ToastStyle.DANGER, 3000);
          return;
        }
        this.navService.pushChildNavPageWithPageTracking(PageName.NewChangeRequestComponent, PageName.NewChangeRequestComponent, PageName.ContactPageComponent, {newActivityDataModel : newActivityModel}).then(()=>{
          this.uiService.prevView = this.uiService.activeView;
          this.uiService.activeView = 'ContactPageRightPaneNav';
          this.uiService.showNewActivity = false;
        });
      } else if (this.hasChangeRequestCategoryOptions()) {
        // businessEdit OFF but the category flow is on: show the categories
        // (plus the OneKey MDM option when mdmEdit is enabled) instead of
        // dropping straight into the MDM edit form.
        const fixedOptions: NewActivityDataModel['displayOptions'] = this.mdmEditFeatureEnabled ? [{
          id: "one_key_information",
          formattedLabel: this.translate.instant('ONE_KEY_MDM_CONTACT_EDIT_INFORMATION'),
          isChecked: false,
          isDisabled: false
        }] : [];
        this.presentCombinedEditMenu(fixedOptions, (data) => this.handleSelectEvent(data));
      } else {
        await this.mdmContactEditFlow();
      }
    } else if (this.mdmEditFeatureEnabled && this.businessLine === BusinessLineVal.VACCINE) {
      if (!this.businessEditFeatureEnabled) {
        if (this.hasChangeRequestCategoryOptions()) {
          const fixedOptions: NewActivityDataModel['displayOptions'] = [{
            id: "one_key_information",
            formattedLabel: this.translate.instant('ONE_KEY_MDM_INFORMATION'),
            isChecked: false,
            isDisabled: false
          }];
          this.presentCombinedEditMenu(fixedOptions, (data) => this.handleSelectEvent(data));
        } else {
          await this.mdmContactEditFlow();
        }
      } else {
        const newActivityModel: NewActivityDataModel = {
          source: ActivitySource.ONE_KEY_CONTACT_EDIT,
          displayOptions: [
            {
              id: "one_key_information",
              formattedLabel: this.translate.instant('ONE_KEY_MDM_INFORMATION'),
              isChecked: true,
              isDisabled:false
            }
          ],
          title: this.translate.instant('EDIT') + " " + this.contactService.contactInformation.fullName,
          eventHandler: this.makeEditOptionDispatcher((data) => this.handleSelectEvent(data))
        }

        if (!this.hideEmailAddressInformationOption) {
          newActivityModel.displayOptions.push({
            id: "business_cr_emailaddress_information",
            formattedLabel: this.translate.instant('EMAIL_ADDRESS_INFORMATION'),
            isChecked: false,
            isDisabled:false
          });
        }

        newActivityModel.displayOptions.push(...this.buildChangeRequestCategoryOptions());
        newActivityModel.displayOptions = this.applyEditMenuOptionConfig(newActivityModel.displayOptions);
        if (newActivityModel.displayOptions.length === 0) {
          this.notificationService.notify(this.translate.instant('NO_OPTIONS_AVAILABLE'), 'ContactInfoComponent', "top", ToastStyle.DANGER, 3000);
          return;
        }
        this.navService.pushChildNavPageWithPageTracking(PageName.NewChangeRequestComponent, PageName.NewChangeRequestComponent, PageName.ContactPageComponent, {newActivityDataModel : newActivityModel}).then(()=>{
          this.uiService.prevView = this.uiService.activeView;
          this.uiService.activeView = 'ContactPageRightPaneNav';
          this.uiService.showNewActivity = false;
        });
      }
    } else if (this.mdmEditFeatureEnabled && (this.businessLine === BusinessLineVal.PHARMA || this.businessLine === BusinessLineVal.RETAIL || this.businessLine === BusinessLineVal.VACCINE_MDM)) {
      this.contactEditOptions();
    } else {
      this.accountService.isOneKeyChangeRequest = false;
      this.contactService.isOneKeyChangeRequest = false;
      if (!this.businessEditFeatureEnabled) {
        if (this.hasChangeRequestCategoryOptions()) {
          // No fixed business option here (businessEdit OFF), but the category
          // flow is on — present a category-only menu rather than opening the
          // default edit form directly.
          this.presentCombinedEditMenu([], (data) => this.handleSelectEvent(data));
        } else {
          await this.defaultContactEditFlow();
        }
      } else {
        const newActivityModel: NewActivityDataModel = {
          source: ActivitySource.ONE_KEY_CONTACT_EDIT,
          displayOptions: [
            {
              id: "business_information_default",
              formattedLabel: this.translate.instant('ONE_KEY_BUSINESS_CONTACT_EDIT_INFORMATION'),
              isChecked: true,
              isDisabled:false
            }
          ],
          title: this.translate.instant('EDIT') + " " + this.contactService.contactInformation.fullName,
          eventHandler: this.makeEditOptionDispatcher((data) => this.handleSelectEvent(data))
        }

        if (!this.hideEmailAddressInformationOption) {
          newActivityModel.displayOptions.push({
            id: "business_cr_emailaddress_information",
            formattedLabel: this.translate.instant('EMAIL_ADDRESS_INFORMATION'),
            isChecked: false,
            isDisabled:false
          });
        }
        newActivityModel.displayOptions.push(...this.buildChangeRequestCategoryOptions());
        newActivityModel.displayOptions = this.applyEditMenuOptionConfig(newActivityModel.displayOptions);
        if (newActivityModel.displayOptions.length === 0) {
          this.notificationService.notify(this.translate.instant('NO_OPTIONS_AVAILABLE'), 'ContactInfoComponent', "top", ToastStyle.DANGER, 3000);
          return;
        }
        this.navService.pushChildNavPageWithPageTracking(PageName.NewChangeRequestComponent, PageName.NewChangeRequestComponent, PageName.ContactPageComponent, {newActivityDataModel : newActivityModel}).then(()=>{
          this.uiService.prevView = this.uiService.activeView;
          this.uiService.activeView = 'ContactPageRightPaneNav';
          this.uiService.showNewActivity = false;
        });
      }
    }

  }

  /**
   * Builds the change-request category options that are appended to an edit
   * menu. Returns an empty array when the category flow feature is off or no
   * categories are configured, so callers can unconditionally spread the
   * result. Category options are always unchecked (the fixed options own the
   * default selection) and each carries `categoryData`, which the unified
   * dispatcher uses to route the selection to the category change-request flow.
   */
  private buildChangeRequestCategoryOptions() {
    if (!this.changeRequestCategoryFlowFeatureEnabled || !this.contactService.changeRequestCategoryTypes?.length) {
      return [];
    }
    const selectedContact = this.contactService.contactInformation;
    const sortedCategories = sortBy(this.contactService.changeRequestCategoryTypes, (category) =>
      (category.indskr_name || category.indskr_description || '').toLowerCase()
    );
    return sortedCategories.map((category) => {
      const changeRequestCategoryId = category.indskr_expertcategoriesid;
      const contactForm = this.dynamicFormsService.getFormDefinitionForEntity('indskr_contactcr', FormType.CREATEFORM, BusinessProcessType.Omnipresence, null, changeRequestCategoryId);
      const isSharedTargetForm = contactForm?.formId?.includes('Exeltis Shared Target CR Form') || false;
      return {
        id: changeRequestCategoryId,
        formattedLabel: category.indskr_name || category.indskr_description || '',
        description: category.indskr_description || '',
        isChecked: false,
        isDisabled: isSharedTargetForm && (!selectedContact.targetLevel || !(selectedContact.targetLevel == TargetLevel.TIER_1 || selectedContact.targetLevel == TargetLevel.TIER_2)),
        categoryData: category
      };
    });
  }

  /**
   * Wraps a fixed-option handler so a selected change-request category routes to
   * the category flow, while fixed options keep their native handler. The
   * presence of `categoryData` is the discriminator — only category options
   * carry it, and the three option id-spaces (category GUIDs, MDM-edit ids,
   * fixed string ids) are disjoint.
   */
  private makeEditOptionDispatcher(nativeHandler: (data: any) => void): (data: any) => void {
    return (data: any) => {
      if (data?.categoryData) {
        this.handleChangeRequestCategorySelect(data);
      } else {
        nativeHandler(data);
      }
    };
  }

  /**
   * Applies the "hide Business Information" BU configuration
   * (BU_CONTACT_GA_HIDEBUSINESSINFORMATIONOPTION) to an edit menu and normalises
   * the default selection. Removes the Business Information option(s) when the
   * config is set (honouring the config even if that empties the menu — callers
   * must guard the empty case), then ensures the first selectable option is the
   * checked default, since the original default may have been the removed one.
   */
  private applyEditMenuOptionConfig(options: NewActivityDataModel['displayOptions']): NewActivityDataModel['displayOptions'] {
    let result = options;
    if (this.hideBusinessInformationOption) {
      result = result.filter(option => option.id !== 'business_information' && option.id !== 'business_information_default');
    }
    if (result.length > 0 && !result.some(option => option.isChecked && !option.isDisabled)) {
      const firstSelectableOption = result.find(option => !option.isDisabled);
      if (firstSelectableOption) {
        firstSelectableOption.isChecked = true;
      }
    }
    return result;
  }

  /**
   * True when the change-request category flow is on AND at least one category
   * is configured — i.e. when buildChangeRequestCategoryOptions() would yield
   * options. Edit branches that otherwise open a flow directly (no option menu)
   * use this to decide whether a combined menu must be shown instead, so the
   * categories are not silently dropped.
   */
  private hasChangeRequestCategoryOptions(): boolean {
    return this.changeRequestCategoryFlowFeatureEnabled && !!this.contactService.changeRequestCategoryTypes?.length;
  }

  /**
   * Presents the combined edit-option menu (the given fixed options followed by
   * the change-request categories), applying the hide-Business-Information
   * config and guarding the empty case. Mirrors the inline menu blocks in
   * editContact() so the edit branches that previously opened a flow directly
   * route categories through the same selection menu.
   */
  private presentCombinedEditMenu(fixedOptions: NewActivityDataModel['displayOptions'], nativeHandler: (data: any) => void): void {
    const newActivityModel: NewActivityDataModel = {
      source: ActivitySource.ONE_KEY_CONTACT_EDIT,
      displayOptions: [...fixedOptions, ...this.buildChangeRequestCategoryOptions()],
      title: this.translate.instant('EDIT') + " " + this.contactService.contactInformation.fullName,
      eventHandler: this.makeEditOptionDispatcher(nativeHandler)
    };
    newActivityModel.displayOptions = this.applyEditMenuOptionConfig(newActivityModel.displayOptions);
    if (newActivityModel.displayOptions.length === 0) {
      this.notificationService.notify(this.translate.instant('NO_OPTIONS_AVAILABLE'), 'ContactInfoComponent', "top", ToastStyle.DANGER, 3000);
      return;
    }
    this.navService.pushChildNavPageWithPageTracking(PageName.NewChangeRequestComponent, PageName.NewChangeRequestComponent, PageName.ContactPageComponent, { newActivityDataModel: newActivityModel }).then(() => {
      this.uiService.prevView = this.uiService.activeView;
      this.uiService.activeView = 'ContactPageRightPaneNav';
      this.uiService.showNewActivity = false;
    });
  }

  private contactEditOptions() {
    if (this.contactService.isInGlobalSearch && this.contactService.isContactInGlobalSearch(this.contactService.contactInformation)) {
      this.mdmAddAccountAffiliation();
    } else {
      const newActivityModel: NewActivityDataModel = {
        source: ActivitySource.ONE_KEY_CONTACT_EDIT,
        displayOptions: [
          {
            id: "change_attribute",
            formattedLabel: this.translate.instant('CHANGE_ATTRIBUTE'),
            isChecked: true,
            isDisabled: false
          },
          {
            id: "add_account_affiliation",
            formattedLabel: this.translate.instant('ADD_ACCOUNT_AFFILIATION'),
            isChecked: false,
            isDisabled: false
          }
        ],
        title: this.translate.instant('EDIT') + " " + this.contactService.contactInformation.fullName,
        eventHandler: this.makeEditOptionDispatcher((data) => this.handleMDMEditSelected(data))
      }
      newActivityModel.displayOptions.push(...this.buildChangeRequestCategoryOptions());
      this.navService.pushChildNavPageWithPageTracking(PageName.NewChangeRequestComponent, PageName.NewChangeRequestComponent, PageName.ContactPageComponent, { newActivityDataModel: newActivityModel });
    }
  }

  private handleMDMEditSelected(data) {
    if (data?.id === 'change_attribute')
      this.mdmContactEditFlow();
    else
      this.mdmAddAccountAffiliation();
  }

  private loadIOSWidget() {
    let activeInstance = this.authService.userConfig.activeInstance;
    const veevaConfig = activeInstance.veevaConfig;

    this.iab.create(`${activeInstance.OmnipresenceWfeUrl}/?veevaWidget=VEEVA_PROFILE&preset=contact&id=${this.contactService.contactInformation.appId}&title=${this.contactService.contactInformation.fullName}&widgetName=${veevaConfig.profileWidgetName}&manifestURL=${veevaConfig.manifestScriptUrl}&widgetURL=${veevaConfig.profileWidgetScriptUrl}&widgetID=${veevaConfig.profileWidgetId}&authDomain=${veevaConfig.authDomain}`, '_system', { location: 'yes', hideurlbar: 'no', hidenavigationbuttons: 'no' });

    return;
  }

  private async defaultContactEditFlow() {
    this.trackingService.tracking('EditSelected', TrackingEventNames.CONTACT_EDIT, true);

    let contactForm: DynamicForm = await this.dynamicFormsService.getFormDefinitionForEntity("contact", FormType.EDITFORM);
    let formType = DynamicFormType.CONFIGUREDFORM;
    if(!contactForm){
      contactForm = new DynamicForm(DEFAULT_CONTACT_CREATE_FORM['value'][0]);
      formType = DynamicFormType.DEFAULTFORM;
    }

    let contactRaw = await this.contactService.contactInformation.raw;
    let contactIdData = {
      contactid: this.contactService.contactInformation.ID,
    };
    let existingLinkedEntityData = [];
    if(this.contactService._defaultLinkedEntityMappingData) {
      existingLinkedEntityData = this.contactService._defaultLinkedEntityMappingData.filter(contact => contact.contactid === this.contactService.contactInformation.ID);
    }
    let formDetails: DynamicFormComponentModel = {
      title: this.translate.instant('EDIT') + " " + this.contactService.contactInformation.fullName,
      LookupEntitySetName: 'contacts',
      showLeftHeaderButton: true,
      leftHeaderBtnIcon: 'chevron-back-outline',
      showRightHeaderButton: true,
      rightHeaderImgSrc: 'assets/imgs/header_save.svg',
      rightHeaderBtnText: this.translate.instant('SAVE'),
      formMetadata: contactForm,
      formEntityObject: contactRaw,
      mainEntityObjectId: contactIdData,
      dynamicFormType: formType,
      linkedEntityValue: existingLinkedEntityData,
      navOptions: { animate: false },
      eventsHandler: (data:any, eventTarget:string, refData:DynamicFormComponentModel)=> this._handleContactFormComponentEvent(data,eventTarget),
    };

    this.navService.pushChildNavPageWithPageTracking(PageName.DynamicFormComponent, PageName.DynamicFormComponent, PageName.ContactPageComponent, {
      MODE:'EDIT_MODE',
      FORM_DETAIL: formDetails,
      RAW_DATA: this.rawFormData,
      REF_ENTITY_NAME: 'contactid'
    }).then(()=>{
      if(this.uiService.activeView === 'ActivitiesPageRightPaneNav' && this.uiService.activitiesPageTab === 'plans') {
        this.uiService.activeView = 'ActivitiesPageRightPaneNav';
      } else {
        this.uiService.activeView = 'ContactPageRightPaneNav';
      }
      this.uiService.showNewActivity = false;
    });
  }

  private async oneKeyContactBusinessInformationEditFlow() {
    this.trackingService.tracking('EditSelected', TrackingEventNames.CONTACT_EDIT, true);

    let contactForm: DynamicForm = await this.dynamicFormsService.getFormDefinitionForEntity("contact", FormType.EDITFORM, BusinessProcessType.OneKey);
    let formType = DynamicFormType.CONFIGUREDFORM;
    if(!contactForm){
      this.uiService.activeView = this.uiService.prevView;
      this.notificationService.notify(this.translate.instant('ONE_KEY_CREATE_FORM_ERROR'), 'DynamicFormComponent', "top", ToastStyle.DANGER, 3000);
      return;
    }

    let contactRaw = await this.contactService.contactInformation.raw;
    let contactIdData = {
      contactid: this.contactService.contactInformation.ID,
    };
    let existingLinkedEntityData = [];
    if(this.contactService._defaultLinkedEntityMappingData) {
      existingLinkedEntityData = this.contactService._defaultLinkedEntityMappingData.filter(contact => contact.contactid === this.contactService.contactInformation.ID);
    }

    let formDetails: DynamicFormComponentModel = {
      title: this.translate.instant('EDIT') + " " + this.contactService.contactInformation.fullName,
      LookupEntitySetName: 'contacts',
      showLeftHeaderButton: true,
      leftHeaderBtnIcon: 'chevron-back-outline',
      showRightHeaderButton: true,
      rightHeaderImgSrc: 'assets/imgs/header_save.svg',
      rightHeaderBtnText: this.translate.instant('SAVE'),
      formMetadata: contactForm,
      formEntityObject: contactRaw,
      mainEntityObjectId: contactIdData,
      dynamicFormType: formType,
      navOptions: { animate: false },
      linkedEntityValue: existingLinkedEntityData,
      eventsHandler: (data:any, eventTarget:string, refData:DynamicFormComponentModel)=> this._handleContactFormComponentEvent(data,eventTarget),
    };

    this.navService.pushChildNavPageWithPageTracking(PageName.DynamicFormComponent, PageName.DynamicFormComponent, PageName.ContactPageComponent, {
      MODE:'EDIT_MODE',
      FORM_DETAIL: formDetails,
      RAW_DATA: this.rawFormData,
      REF_ENTITY_NAME: 'contactid'
    }).then(()=>{
      if(this.uiService.activeView === 'ActivitiesPageRightPaneNav' && this.uiService.activitiesPageTab === 'plans') {
        this.uiService.activeView = 'ActivitiesPageRightPaneNav';
      } else {
        this.uiService.activeView = 'ContactPageRightPaneNav';
      }
      this.uiService.showNewActivity = false;
    });
  }

  private async businessContacCREmailCRInfoEditFlow() {
    this.trackingService.tracking('EditSelected', TrackingEventNames.CONTACT_EDIT, true);
    let contactForm: DynamicForm = await this.dynamicFormsService.getFormDefinitionForEntity("indskr_contactcr", FormType.EDITFORM, BusinessProcessType.Omnipresence, FormChangeRequestType.Update);
    let formType = DynamicFormType.CONFIGUREDFORM;
    if(!contactForm){
      this.uiService.activeView = this.uiService.prevView;
      // this.notificationService.notify(this.translate.instant('CHANGE_REQUEST_FORM_ERROR'), 'DynamicFormComponent', "top", ToastStyle.DANGER, 3000);
      return;
    }

    let contactRaw = await this.contactService.contactInformation.raw;
    contactRaw = {
      indskr_mdmrequesttype: MDMRequestType.UPDATE_EMAIL,
      ...contactRaw
    }

    this.mdmService.addLinkEntities([]);
    let existingLinkedEntityData = [];
    if(this.contactService._defaultLinkedEntityMappingData) {
      existingLinkedEntityData = this.contactService._defaultLinkedEntityMappingData.filter(contact => contact.contactid === this.contactService.contactInformation.ID);
    }

    let formDetails: DynamicFormComponentModel = {
      title: this.translate.instant('EDIT') + " " + this.contactService.contactInformation.fullName,
      LookupEntitySetName: 'indskr_contactcrs',
      showLeftHeaderButton: true,
      enableSubgridDataEditing: true,
      leftHeaderBtnIcon: 'chevron-back-outline',
      showRightHeaderButton: true,
      rightHeaderImgSrc: 'assets/imgs/header_save.svg',
      rightHeaderBtnText: this.translate.instant('SAVE'),
      formMetadata: contactForm,
      formEntityObject: contactRaw,
      mainEntityObjectId: null,
      dynamicFormType: formType,
      navOptions: { animate: false },
      linkedEntityValue: existingLinkedEntityData,
      eventsHandler: (data:any, eventTarget:string, refData:DynamicFormComponentModel)=> this._handleEmailCRFormComponentEvent(data,eventTarget,refData),
    };

    this.navService.pushChildNavPageWithPageTracking(PageName.DynamicFormComponent, PageName.DynamicFormComponent, PageName.ContactPageComponent, {
      MODE:'EDIT_MODE',
      FORM_DETAIL: formDetails,
      RAW_DATA: this.rawFormData,
      REF_ENTITY_NAME: 'contactid',
      TYPE: "OMNIPRESENCE",
      EDIT_FLOW: "business_contact_cr_email_address_cr"
    }).then(()=>{
      if(this.uiService.activeView === 'ActivitiesPageRightPaneNav' && this.uiService.activitiesPageTab === 'plans') {
        this.uiService.activeView = 'ActivitiesPageRightPaneNav';
      } else {
        this.uiService.activeView = 'ContactPageRightPaneNav';
      }
      this.uiService.showNewActivity = false;
    });
  }

  private async handleSelectEvent(data) {
    switch (data.id) {
      case "one_key_information":
        await this.mdmContactEditFlow();
        break;
      case "business_information":
        await this.oneKeyContactBusinessInformationEditFlow();
        break;
      case "business_cr_emailaddress_information":
        await this.businessContacCREmailCRInfoEditFlow();
        break;
      case "business_information_default":
        await this.defaultContactEditFlow();
        break;
      default:
        break;
    }
  }

  // Fields whose source attribute name differs from the convention and is
  // therefore mapped explicitly in mapContactRawFields; skipped by the generic
  // resolver so the explicit mapping is not overwritten.
  private static readonly CR_EXPLICITLY_MAPPED_FIELDS = new Set([
    'exe_noseeflag_new', 'exe_deletereason_new', 'indskr_mdmrequesttype', 'indskr_mdm'
  ]);

  // Explicit source aliases for CR fields whose name diverges from the contact's
  // attribute by more than a prefix (so the generic derivation can't bridge it),
  // and where no targetEntityAttribute config is supplied. The contact may store
  // the value under either the field's own key or the alias, so both are tried.
  private static readonly CR_FIELD_SOURCE_ALIASES: { [crField: string]: string } = {
    indskr_lu_professional_designationid: 'omnione_lu_professionaldesignation',
    indskr_primaryemail: 'emailaddress1'
  };

  /**
   * Maps the contact's current values onto the change-request form's "new value"
   * mirror fields so the category form pre-fills with existing data.
   *
   * Source attribute resolution per control (first match wins):
   *   1) control.targetEntityAttribute - client-agnostic field configuration.
   *   2) explicit CR_FIELD_SOURCE_ALIASES entry for divergent names.
   *   3) same-prefix custom source: the CR field name minus "_new"
   *      ("<prefix>_<base>_new" -> "<prefix>_<base>", e.g. exe_deletereason_new
   *      -> exe_deletereason) so custom client fields resolve without a hardcode.
   *   4) prefix-agnostic naming convention ("indskr_firstname" -> firstname,
   *      "<prefix>_<base>_new" -> base) as a fallback.
   * Lookups additionally receive the "_<attr>_value" GUID and its OData
   * formatted (display) value, which is what the dynamic form renders.
   */
  private mapContactRawFields(contactRaw: any, contactForm: DynamicForm, changeRequestCategoryId: string, changeRequestCategoryName: string): any {
    const fieldMappings: any = {
      indskr_mdm: this.contactService.contactInformation.mdmType,
      indskr_mdmrequesttype: MDMRequestType.CREATE,
      indskr_changerequestcategoryid: changeRequestCategoryId,
      indskr_changerequestcategoryname: changeRequestCategoryName,
      exe_noseeflag_new: contactRaw?.exe_noseeflag1 ?? '',
      exe_deletereason_new: contactRaw?.exe_deletereason ?? '',
      'exe_deletereason_new@OData.Community.Display.V1.FormattedValue': contactRaw?.['exe_deletereason@OData.Community.Display.V1.FormattedValue'] ?? ''
    };

    if (!contactForm?.metadata?.length) {
      return { ...fieldMappings, ...contactRaw };
    }

    const allControls = contactForm.metadata.flatMap(section => section.controls || []);

    allControls.forEach((control: Control) => {
      const attributeName = control?.attributeName;
      if (!attributeName || ContactInfoComponent.CR_EXPLICITLY_MAPPED_FIELDS.has(attributeName)) {
        return;
      }

      const sourceAttributes = [
        control.targetEntityAttribute,
        ContactInfoComponent.CR_FIELD_SOURCE_ALIASES[attributeName],
        // Same-prefix custom field: the contact stores the value under the CR
        // field's own (publisher-prefixed) name minus the "_new" suffix, e.g.
        // exe_deletereason_new <- exe_deletereason, acme_foo_new <- acme_foo.
        attributeName.replace(/_new$/, ''),
        this.deriveCrSourceAttribute(attributeName)
      ].filter(Boolean);
      if (!sourceAttributes.length) {
        return;
      }

      this.assignContactSourceValue(fieldMappings, contactRaw, control, sourceAttributes);
    });

    const merged = { ...fieldMappings, ...contactRaw };

    // Mirror bare base fields into their indskr_<base> custom-attribute controls.
    // The contactcr form declares custom string controls under the indskr_ prefix
    // (e.g. indskr_firstname / indskr_lastname), but contactInformation.raw stores the
    // values under bare keys (firstname / lastname). Without this mirror the form
    // cannot resolve a value for those controls and the fields render blank.
    // Only fill when the prefixed key is empty so real indskr_* data is never clobbered.
    contactForm.metadata
      .flatMap(section => section.controls || [])
      .forEach(control => {
        const attributeName = control?.attributeName;
        if (!control?.isCustomAttribute || !attributeName?.startsWith('indskr_')) {
          return;
        }
        const baseFieldName = attributeName.slice('indskr_'.length);
        const baseValue = contactRaw[baseFieldName];
        const isPrefixedEmpty = merged[attributeName] === undefined || merged[attributeName] === null || merged[attributeName] === '';
        const hasBaseValue = baseValue !== undefined && baseValue !== null && baseValue !== '';
        if (isPrefixedEmpty && hasBaseValue) {
          merged[attributeName] = baseValue;
        }
      });

    return merged;
  }

  /**
   * Derives the contact source attribute a CR mirror field maps from, without
   * assuming a single publisher prefix. CR fields mirror contact attributes as
   * either "<prefix>_<base>" (e.g. indskr_firstname -> firstname) or
   * "<prefix>_<base>_new". Strips an optional "_new" suffix and the leading
   * solution prefix; assignContactSourceValue then resolves the base against
   * both its bare and indskr_ prefixed forms on the raw contact.
   */
  private deriveCrSourceAttribute(attributeName: string): string | null {
    let base = attributeName.replace(/_new$/, '');
    const separatorIndex = base.indexOf('_');
    if (separatorIndex > 0) {
      base = base.slice(separatorIndex + 1);
    }
    return base || null;
  }

  /**
   * Copies a contact value into the CR form payload under the CR field's
   * attribute name. Each candidate source attribute is tried under both its bare
   * and indskr_ prefixed forms; the first that exists on the contact wins. This
   * lets divergent fields list several possible sources (e.g. a designation that
   * may live under indskr_ or omnione_). Lookup controls render from
   * "_<attr>_value" plus the OData formatted value, so both are emitted.
   */
  private assignContactSourceValue(target: any, contactRaw: any, control: Control, sourceAttributes: string[]): void {
    const attributeName = control.attributeName;
    const sourceCandidates = sourceAttributes.flatMap(sourceAttribute => [sourceAttribute, `indskr_${sourceAttribute}`]);

    if (control.dataType === ControlDataType.LookupType) {
      for (const candidate of sourceCandidates) {
        const valueKey = `_${candidate}_value`;
        if (contactRaw[valueKey] !== undefined && contactRaw[valueKey] !== null) {
          target[`_${attributeName}_value`] = contactRaw[valueKey];
          target[`_${attributeName}_value@OData.Community.Display.V1.FormattedValue`] =
            contactRaw[`${valueKey}@OData.Community.Display.V1.FormattedValue`] ?? '';
          return;
        }
      }
      return;
    }

    for (const candidate of sourceCandidates) {
      if (contactRaw[candidate] !== undefined && contactRaw[candidate] !== null) {
        target[attributeName] = contactRaw[candidate];
        const formattedValue = contactRaw[`${candidate}@OData.Community.Display.V1.FormattedValue`];
        if (formattedValue !== undefined) {
          target[`${attributeName}@OData.Community.Display.V1.FormattedValue`] = formattedValue;
        }
        return;
      }
    }
  }

  private async handleChangeRequestCategorySelect(data) {
    if (data && data.id) {
      if (this.device.isOffline) {
        this.notificationService.notify(this.translate.instant('DEVICE_NEEDS_TO_BE_ONLINE_TO_CREATE_CHANGE_REQUEST'), 'ContactInfoComponent', "top", ToastStyle.DANGER, 3000);
        return;
      }

      const changeRequestCategoryId = data.id;
      const changeRequestCategoryName = data.formattedLabel;

      // Store the selected change request category info for use in the handler
      this.selectedChangeRequestCategoryId = changeRequestCategoryId;
      this.selectedChangeRequestCategoryName = changeRequestCategoryName;

      let contactForm: DynamicForm = await this.dynamicFormsService.getFormDefinitionForEntity('indskr_contactcr', FormType.CREATEFORM, BusinessProcessType.Omnipresence, null, changeRequestCategoryId);
      this.currentChangeRequestFormId = contactForm?.formId || null;
      this.currentChangeRequestCategoryForm = contactForm || null;
      let formType = DynamicFormType.CONFIGUREDFORM;
      if (!contactForm) {
        this.uiService.activeView = this.uiService.prevView;
        this.notificationService.notify(this.translate.instant('ONE_KEY_CREATE_FORM_ERROR'), 'DynamicFormComponent', "top", ToastStyle.DANGER, 3000);
        return;
      }

      let contactRaw = await this.contactService.contactInformation.raw;
      contactRaw = this.mapContactRawFields(contactRaw, contactForm, changeRequestCategoryId, changeRequestCategoryName);
      this.mdmService.addLinkEntities([]);
      let existingLinkedEntityData = [];
      if(this.contactService._defaultLinkedEntityMappingData) {
        existingLinkedEntityData = this.contactService._defaultLinkedEntityMappingData.filter(contact => contact.contactid === this.contactService.contactInformation.ID);
      }

      let formDetails: DynamicFormComponentModel = {
        title: this.translate.instant('EDIT') + " " + this.contactService.contactInformation.fullName,
        LookupEntitySetName: 'indskr_contactcrs',
        showLeftHeaderButton: true,
        leftHeaderBtnIcon: 'chevron-back-outline',
        showRightHeaderButton: true,
        rightHeaderImgSrc: 'assets/imgs/header_save.svg',
        rightHeaderBtnText: this.translate.instant('SAVE'),
        formMetadata: contactForm,
        formEntityObject: contactRaw,
        mainEntityObjectId: null,
        dynamicFormType: formType,
        enableSubgridDataEditing: true,
        navOptions: { animate: false },
        linkedEntityValue: existingLinkedEntityData,
        eventsHandler: (data:any, eventTarget:string, refData:DynamicFormComponentModel)=> this._handleChangeRequestCategoryFlow(data,eventTarget),
      };

      this.navService.pushChildNavPageWithPageTracking(PageName.DynamicFormComponent, PageName.DynamicFormComponent, PageName.ContactPageComponent, {
        MODE:'CREATE_MODE',
        FORM_DETAIL: formDetails,
        RAW_DATA: this.rawFormData,
        REF_ENTITY_NAME: 'contactid',
        TYPE: "OMNIPRESENCE",
        EDIT_FLOW: "change_request_category_flow"
      }).then(()=>{
        if(this.uiService.activeView === 'ActivitiesPageRightPaneNav' && this.uiService.activitiesPageTab === 'plans') {
          this.uiService.activeView = 'ActivitiesPageRightPaneNav';
        } else {
          this.uiService.activeView = 'ContactPageRightPaneNav';
        }
        this.uiService.showNewActivity = false;
      });
    }
  }

  private async mdmAddAccountAffiliation() {
    let contactForm: DynamicForm = null;
    let sanofiChinaForm: DynamicForm = await this.dynamicFormsService.getFormDefinitionForEntity("indskr_contactcr", FormType.EDITFORM, BusinessProcessType.SanofiChina);
    let oneKeyForm: DynamicForm = await this.dynamicFormsService.getFormDefinitionForEntity("indskr_contactcr", FormType.EDITFORM, BusinessProcessType.OneKey);
    let formType = DynamicFormType.CONFIGUREDFORM;
    if (!oneKeyForm && !sanofiChinaForm) {
      this.notificationService.notify(this.translate.instant('ONE_KEY_CREATE_FORM_ERROR'), 'DynamicFormComponent', "top", ToastStyle.DANGER, 3000);
      return;
    }
    if (oneKeyForm && sanofiChinaForm) {
      this.notificationService.notify(this.translate.instant('MORE_THAN_ONE_FORM_CONFIGURED_ERR'), 'DynamicFormComponent', "top", ToastStyle.DANGER, 3000);
      return;
    }
    contactForm = oneKeyForm ? oneKeyForm : sanofiChinaForm;
    if(!contactForm){
      this.notificationService.notify(this.translate.instant('ONE_KEY_CREATE_FORM_ERROR'), 'DynamicFormComponent', "top", ToastStyle.DANGER, 3000);
      return;
    }

    // const businessProcess = contactForm.raw && contactForm.raw['indskr_businessprocess'] ? 'SANOFI_CHINA' : 'ONE_KEY';
    const businessProcess = contactForm.raw && contactForm.raw['indskr_businessprocess'] == BusinessProcessType.SanofiChina ? 'SANOFI_CHINA' : 'ONE_KEY';

    let rawObjectData = this.rawFormData;
    rawObjectData = {
      indskr_firstname: this.contactService.contactInformation.firstName,
      indskr_lastname: this.contactService.contactInformation.lastName,
      indskr_mdm: businessProcess == 'SANOFI_CHINA' ? 600000000 : this.contactService.contactInformation.mdmType,
      indskr_mdmrequesttype: MDMRequestType.ADD_AFFILIATION,
      ...rawObjectData
    }

    if (businessProcess == 'SANOFI_CHINA' && this.contactService.contactInformation.raw) {
      let buLine = this.authService.user?.buConfigs?.indskr_businessline;
      let attrName = '';
      rawObjectData['indskr_lastname'] = this.contactService.contactInformation.raw['fullname'];
      if (this.contactService.contactInformation.raw['gendercode']) {
        attrName = 'indskr_gendercode';
        rawObjectData[attrName] = this.contactService.contactInformation.raw['gendercode'];
        rawObjectData[attrName+'@OData.Community.Display.V1.FormattedValue'] = this.contactService.contactInformation.raw['gendercode@OData.Community.Display.V1.FormattedValue'];
      }
      if (!isEmpty(this.contactService.contactInformation.accountRelationships) && buLine) {
        const accAffiliations = this.contactService.contactInformation.accountRelationships;
        if (accAffiliations.length > 0) {
          let affiliation = accAffiliations.map(aff => aff['indskr_jobtitle']);
          if (!isEmpty(affiliation)) {
            let rControl = null;
            if (buLine === BusinessLineVal.PHARMA) {
              attrName = 'indskr_rolepharma';
              rControl = this.getFormControl(contactForm, attrName);
            } else if (buLine === BusinessLineVal.RETAIL) {
              attrName = 'indskr_positionretail';
              rControl = this.getFormControl(contactForm, attrName);
            } else {
              attrName = 'indskr_rolevaccine';
              rControl = this.getFormControl(contactForm, attrName);
            }
            if (rControl) {
              const option = this.getOptionSetMap(rControl, affiliation[0]);
              rawObjectData[attrName] = option.key;
              rawObjectData[attrName+'@OData.Community.Display.V1.FormattedValue'] = option.value;
            }
          }
          if (buLine === BusinessLineVal.VACCINE) {
            let dept_nm = accAffiliations.map(aff => aff['indskr_department'])[0];
            attrName = 'indskr_departmentvaccine';
            const dControl = this.getFormControl(contactForm, attrName);
            if (dControl) {
              const option = this.getOptionSetMap(dControl, dept_nm);
              rawObjectData[attrName] = option.key;
              rawObjectData[attrName+'@OData.Community.Display.V1.FormattedValue'] = option.value;
            }
          }
        }
      }
      if (buLine === BusinessLineVal.PHARMA || buLine === BusinessLineVal.RETAIL || buLine === BusinessLineVal.VACCINE_MDM) {
        if (this.contactService.contactInformation.raw['indskr_title_Formatted']) {
          attrName = (buLine === BusinessLineVal.PHARMA || buLine === BusinessLineVal.VACCINE_MDM) ? 'indskr_titlepharma' : 'indskr_titleretail';
          const dControl = this.getFormControl(contactForm, attrName);
          if (dControl) {
            const option = this.getOptionSetMap(dControl, this.contactService.contactInformation.raw['indskr_title_Formatted']);
            rawObjectData[attrName] = option.key;
            rawObjectData[attrName + '@OData.Community.Display.V1.FormattedValue'] = option.value;
          }
        }
        if (buLine === BusinessLineVal.RETAIL && this.contactService.contactInformation.raw['indskr_position_Formatted']) {
          attrName = 'indskr_positionretail';
          const dControl = this.getFormControl(contactForm, attrName);
          if (dControl) {
            const option = this.getOptionSetMap(dControl, this.contactService.contactInformation.raw['indskr_position_Formatted']);
            rawObjectData[attrName] = option.key;
            rawObjectData[attrName + '@OData.Community.Display.V1.FormattedValue'] = option.value;
          }
        }
      }
      if (!isEmpty(this.contactService.contactInformation.accountRelationships) || !isEmpty(this.contactService.contactInformation.primaryAccount)) {
        if (!isEmpty(this.contactService.contactInformation.accountRelationships)) {
          rawObjectData['_indskr_account_value'] = this.contactService.contactInformation.accountRelationships[0].accountId;
          rawObjectData['_indskr_account_value@OData.Community.Display.V1.FormattedValue'] = this.contactService.contactInformation.accountRelationships[0].accountName;
        } else {
          rawObjectData['_indskr_account_value'] = this.contactService.contactInformation.primaryAccount.id;
          rawObjectData['_indskr_account_value@OData.Community.Display.V1.FormattedValue'] = this.contactService.contactInformation.primaryAccount.accountName;
        }

        if (BusinessLineVal.PHARMA || buLine === BusinessLineVal.VACCINE_MDM) {
          // Get account detail
          const account = this.accountService.getAccountById(rawObjectData['_indskr_account_value']);
          if (account?.raw && account.raw['indskr_hcotype']) {
            rawObjectData['_indskr_account_indskr_hcotype'] = account.raw['indskr_hcotype'];
          }
        }
      }
      if (this.contactService.contactInformation.primarySpecialty) {
        rawObjectData['_indskr_specialty_value'] = this.contactService.contactInformation.primarySpecialty.id;
        rawObjectData['_indskr_specialty_value@OData.Community.Display.V1.FormattedValue'] = this.contactService.contactInformation.primarySpecialty.name;
      }
    }

    // if (businessProcess == 'SANOFI_CHINA' && this.contactService.contactInformation) {
    //   rawObjectData['_indskr_accountid_value'] = this.contactService.contactInformation.primaryAccount.id;
    //   rawObjectData['_indskr_accountid_value@OData.Community.Display.V1.FormattedValue'] = this.contactService.contactInformation.primaryAccount.accountName;
    // }

    // for (let i = 0; i < contactForm.metadata.length; i++) {
    //   const itab = contactForm.metadata[i];
    //   this.removeOldOptionSetIfLookupIsPresent(itab, contactForm, i, "indskr_affiliationrole", "indskr_contactrole");
    //   if (itab && itab.controls && itab.controls.length > 0) {
    //     this.getFieldsToDisplayForContactAccountAff(itab, 'indskr_accountid');
    //   }
    // }

    for (let i = 0; i < contactForm.metadata.length; i++) {
      const itab = contactForm.metadata[i];
      // this.removeOldOptionSetIfLookupIsPresent(itab, contactForm, i, "indskr_affiliationrole", "indskr_contactrole");
      if (itab && itab.controls && itab.controls.length > 0) {
        this.getFieldsReadOnlyAccAffliation(itab);
      }
    }

    const contactRaw = rawObjectData;
    this.mdmService.addLinkEntities([]);
    let formDetails: DynamicFormComponentModel = {
      title: this.translate.instant('EDIT') + " " + this.contactService.contactInformation.fullName,
      LookupEntitySetName: 'indskr_contactcrs',
      showLeftHeaderButton: true,
      leftHeaderBtnIcon: 'chevron-back-outline',
      showRightHeaderButton: true,
      rightHeaderImgSrc: 'assets/imgs/header_save.svg',
      rightHeaderBtnText: this.translate.instant('SAVE'),
      formMetadata: contactForm,
      formEntityObject: contactRaw,
      mainEntityObjectId: null,
      dynamicFormType: formType,
      navOptions: { animate: false },
      eventsHandler: (data:any, eventTarget:string, refData:DynamicFormComponentModel)=> this._handleAddAccountAffiliationFormComponentEvent(data,eventTarget),
    };

    this.navService.pushChildNavPageWithPageTracking(PageName.DynamicFormComponent, PageName.DynamicFormComponent, PageName.ContactPageComponent, {
      MODE:'EDIT_MODE',
      FORM_DETAIL: formDetails,
      TYPE: businessProcess
    }).then(()=>{
      this.uiService.activeView = 'ContactPageRightPaneNav';
      this.uiService.showNewActivity = false;
    });
  }

  private removeOldOptionSetIfLookupIsPresent(itab: any, foundForm: any, i: number, newLookUpAttribute: string, oldOptionSetAttribute: string) {
    const affRoleIndex = itab.controls.findIndex(control => control.attributeName == newLookUpAttribute);
    if (affRoleIndex >= 0) {
      const roleIndex = itab.controls.findIndex(control => control.attributeName == oldOptionSetAttribute);
      if (roleIndex >= 0) {
        itab.controls.splice(roleIndex, 1);
        foundForm.metadata[i] = itab;
      }
    }
  }

  private getFieldsToDisplayForContactAccountAff(itab: any, attributeToDisplay: string) {
    itab.controls.filter(c => (c.attributeName == 'indskr_contactcr' || c.attributeName == 'indskr_accountcr' || c.attributeName == 'indskr_contactid' || c.attributeName == 'indskr_accountid'))
      .forEach(control => {
         if (control.attributeName == attributeToDisplay) {
          control.forceHide = false;
          control.isRequired = true;
        } else {
          control.forceHide = true;
          control.isRequired = false;
        }
      });
  }

  private getFieldsToHideForChangeAAttributes(itab: any) {
    itab.controls.filter(c => (c.lookupEntitySetName == 'indskr_accountcontactaffiliationcrs'))
      .forEach(control => {
        control.forceHide = true;
        control.isRequired = false;
      });
  }

  private getFieldsReadOnlyAccAffliation(itab: any) {
    itab.controls.filter(c => (c.attributeName == 'indskr_lastname' || c.attributeName == 'indskr_gendercode' || c.attributeName == 'indskr_account' || c.attributeName == 'indskr_specialty' || c.attributeName == 'indskr_titlepharma'))
      .forEach(control => {
        control.isReadOnly = true;
      });
  }

  private async mdmContactEditFlow() {
    let contactForm: DynamicForm = null;
    let sanofiChinaForm: DynamicForm = await this.dynamicFormsService.getFormDefinitionForEntity("indskr_contactcr", FormType.EDITFORM, BusinessProcessType.SanofiChina);
    let oneKeyForm: DynamicForm = await this.dynamicFormsService.getFormDefinitionForEntity("indskr_contactcr", FormType.EDITFORM, BusinessProcessType.OneKey);
    let formType = DynamicFormType.CONFIGUREDFORM;
    if (!oneKeyForm && !sanofiChinaForm) {
      this.notificationService.notify(this.translate.instant('ONE_KEY_CREATE_FORM_ERROR'), 'DynamicFormComponent', "top", ToastStyle.DANGER, 3000);
      return;
    }
    if (oneKeyForm && sanofiChinaForm) {
      this.notificationService.notify(this.translate.instant('MORE_THAN_ONE_FORM_CONFIGURED_ERR'), 'DynamicFormComponent', "top", ToastStyle.DANGER, 3000);
      return;
    }
    contactForm = oneKeyForm ? oneKeyForm : sanofiChinaForm;
    if(!contactForm){
      this.notificationService.notify(this.translate.instant('ONE_KEY_CREATE_FORM_ERROR'), 'DynamicFormComponent', "top", ToastStyle.DANGER, 3000);
      return;
    }

    // const businessProcess = contactForm.raw && contactForm.raw['indskr_businessprocess'] ? 'SANOFI_CHINA' : 'ONE_KEY';
    const businessProcess = contactForm.raw && contactForm.raw['indskr_businessprocess'] == BusinessProcessType.SanofiChina ? 'SANOFI_CHINA' : 'ONE_KEY';

    let rawObjectData = this.rawFormData;
    rawObjectData = {
      indskr_firstname: this.contactService.contactInformation.firstName,
      indskr_lastname: this.contactService.contactInformation.lastName,
      indskr_mdm: businessProcess == 'SANOFI_CHINA' ? 600000000 : this.contactService.contactInformation.mdmType,
      indskr_mdmrequesttype: MDMRequestType.UPDATE,
      ...rawObjectData
    }

    if (businessProcess == 'SANOFI_CHINA' && this.contactService.contactInformation.raw) {
      let buLine = this.authService.user?.buConfigs?.indskr_businessline;
      let attrName = '';
      rawObjectData['indskr_lastname'] = this.contactService.contactInformation.raw['fullname'];
      if (this.contactService.contactInformation.raw['gendercode']) {
        attrName = 'indskr_gendercode';
        rawObjectData[attrName] = this.contactService.contactInformation.raw['gendercode'];
        rawObjectData[attrName+'@OData.Community.Display.V1.FormattedValue'] = this.contactService.contactInformation.raw['gendercode@OData.Community.Display.V1.FormattedValue'];
      }
      if (!isEmpty(this.contactService.contactInformation.accountRelationships) && buLine) {
        const accAffiliations = this.contactService.contactInformation.accountRelationships;
        if (accAffiliations.length > 0) {
          let affiliation = accAffiliations.map(aff => aff['indskr_jobtitle']);
          if (!isEmpty(affiliation)) {
            let rControl = null;
            if (buLine === BusinessLineVal.PHARMA) {
              attrName = 'indskr_rolepharma';
              rControl = this.getFormControl(contactForm, attrName);
            } else {
              attrName = 'indskr_rolevaccine';
              rControl = this.getFormControl(contactForm, attrName);
            }
            if (rControl) {
              const option = this.getOptionSetMap(rControl, affiliation[0]);
              rawObjectData[attrName] = option.key;
              rawObjectData[attrName+'@OData.Community.Display.V1.FormattedValue'] = option.value;
            }
          }
          if (buLine === BusinessLineVal.VACCINE) {
            let dept_nm = accAffiliations.map(aff => aff['indskr_department'])[0];
            attrName = 'indskr_departmentvaccine';
            const dControl = this.getFormControl(contactForm, attrName);
            if (dControl) {
              const option = this.getOptionSetMap(dControl, dept_nm);
              rawObjectData[attrName] = option.key;
              rawObjectData[attrName+'@OData.Community.Display.V1.FormattedValue'] = option.value;
            }
          }
        }
      }
      if (buLine === BusinessLineVal.PHARMA || buLine === BusinessLineVal.RETAIL || buLine === BusinessLineVal.VACCINE_MDM) {
        if (this.contactService.contactInformation.raw['indskr_title_Formatted']) {
          attrName = (buLine === BusinessLineVal.PHARMA || buLine === BusinessLineVal.VACCINE_MDM) ? 'indskr_titlepharma' : 'indskr_titleretail';
          const dControl = this.getFormControl(contactForm, attrName);
          if (dControl) {
            const option = this.getOptionSetMap(dControl, this.contactService.contactInformation.raw['indskr_title_Formatted']);
            rawObjectData[attrName] = option.key;
            rawObjectData[attrName + '@OData.Community.Display.V1.FormattedValue'] = option.value;
          }
        }
        if (buLine === BusinessLineVal.RETAIL && this.contactService.contactInformation.raw['indskr_position_Formatted']) {
          attrName = 'indskr_positionretail';
          const dControl = this.getFormControl(contactForm, attrName);
          if (dControl) {
            const option = this.getOptionSetMap(dControl, this.contactService.contactInformation.raw['indskr_position_Formatted']);
            rawObjectData[attrName] = option.key;
            rawObjectData[attrName + '@OData.Community.Display.V1.FormattedValue'] = option.value;
          }
        }
      }
      if (!isEmpty(this.contactService.contactInformation.accountRelationships) || !isEmpty(this.contactService.contactInformation.primaryAccount)) {
        if (!isEmpty(this.contactService.contactInformation.accountRelationships)) {
          rawObjectData['_indskr_account_value'] = this.contactService.contactInformation.accountRelationships[0].accountId;
          rawObjectData['_indskr_account_value@OData.Community.Display.V1.FormattedValue'] = this.contactService.contactInformation.accountRelationships[0].accountName;
        } else {
          rawObjectData['_indskr_account_value'] = this.contactService.contactInformation.primaryAccount.id;
          rawObjectData['_indskr_account_value@OData.Community.Display.V1.FormattedValue'] = this.contactService.contactInformation.primaryAccount.accountName;
        }

        if (buLine === BusinessLineVal.PHARMA || buLine === BusinessLineVal.VACCINE_MDM) {
          // Get account detail
          const account = this.accountService.getAccountById(rawObjectData['_indskr_account_value']);
          if (account?.raw && account.raw['indskr_hcotype']) {
            rawObjectData['_indskr_account_indskr_hcotype'] = account.raw['indskr_hcotype'];
          }
        }
      }
      if (this.contactService.contactInformation.primarySpecialty) {
        rawObjectData['_indskr_specialty_value'] = this.contactService.contactInformation.primarySpecialty.id;
        rawObjectData['_indskr_specialty_value@OData.Community.Display.V1.FormattedValue'] = this.contactService.contactInformation.primarySpecialty.name;
      }

      for (let i = 0; i < contactForm.metadata.length; i++) {
        const itab = contactForm.metadata[i];
        if (itab && itab.controls && itab.controls.length > 0) {
          this.getFieldsToHideForChangeAAttributes(itab);
        }
      }
    }

    const contactRaw = rawObjectData;
    this.mdmService.addLinkEntities([]);
    let formDetails: DynamicFormComponentModel = {
      title: this.translate.instant('EDIT') + " " + this.contactService.contactInformation.fullName,
      LookupEntitySetName: 'indskr_contactcrs',
      showLeftHeaderButton: true,
      leftHeaderBtnIcon: 'chevron-back-outline',
      showRightHeaderButton: true,
      rightHeaderImgSrc: 'assets/imgs/header_save.svg',
      rightHeaderBtnText: this.translate.instant('SAVE'),
      formMetadata: contactForm,
      formEntityObject: contactRaw,
      mainEntityObjectId: null,
      dynamicFormType: formType,
      navOptions: { animate: false },
      eventsHandler: (data:any, eventTarget:string, refData:DynamicFormComponentModel)=> this._handleOneKeyContactFormComponentEvent(data,eventTarget),
    };

    this.navService.pushChildNavPageWithPageTracking(PageName.DynamicFormComponent, PageName.DynamicFormComponent, PageName.ContactPageComponent, {
      MODE:'EDIT_MODE',
      FORM_DETAIL: formDetails,
      TYPE: businessProcess
    }).then(()=>{
      this.uiService.activeView = 'ContactPageRightPaneNav';
      this.uiService.showNewActivity = false;
    });
  }

  private getFormControl(form: DynamicForm, key): Control {
    let control: Control;
    form.metadata.forEach(e => {
      control = e.controls.find(c => c.attributeName == key);
    })
    return control;
  }

  private getOptionSetMap(control, value) {
    const optionMap = {key:"", value:""};
    const options = control.optionSet;
    options.forEach(o => {
      if (o['displayNames'] && !isEmpty(o['displayNames'])) {
        o['displayNames'].forEach(d => {
          if (d['description'] && d['description'] == value) {
            optionMap['key'] = o['value'];
            optionMap['value'] = d['description'];
          }
        })
      }
    })
    return optionMap;
  }

  private async _handleContactFormComponentEvent(data, eventTarget){
    if(eventTarget){
      if(eventTarget == 'DONEBUTTONCLICK'){
        if(data && data.formValue) {
          this.trackingService.tracking('SaveSelected', TrackingEventNames.CONTACT_EDIT, true);
          let loader = await this.loadingCtrl.create();
          loader.present();
          if(this.linkEntitiesReqPayload && this.linkEntitiesReqPayload.length>0){
            const accountContactAffReqPayload = [];
            for (let reqPayload of this.linkEntitiesReqPayload) {
              /*************Edit business information in offline - Non-OneKey contacts*************/
              if(this.contactDataService.isOfflineForAddedNewData(reqPayload)) {
                this.disk.createOfflineLinkedEntity(reqPayload);
                  //To update linked entities for the contact saved
                await this._addOfflineLinkedEntityToDisk(reqPayload);
              }
              /*************Edit business information in offline - Non-OneKey contacts*************/
              else {
                await this.dynamicFormsService.createLinkedEntity(reqPayload.values, reqPayload.entity);
                if (reqPayload.entity === 'indskr_accountcontactaffiliations' && !reqPayload.values.statecode) {
                  accountContactAffReqPayload.push({
                    accountId: reqPayload.values['lookupfields']?.find(req => req['entity'] === 'accounts').id,
                    accountName: null,
                    contactId: reqPayload.values['lookupfields']?.find(req => req['entity'] === 'contacts').id,
                    indskr_accounttype: null
                  });
                }
              }
            }
            this.events.publish("marketScan:newAccountContactAff", accountContactAffReqPayload);
            this.linkEntitiesReqPayload = [];
          }

          /*************Edit business information in offline - Non-OneKey contacts*************/
          if (this.contactDataService.isOffline(data.formValue)) {
            this.contactDataService.addToOfflineContactsIds(data.formValue.contactid);
            await this.disk.createOfflineContact(data.formValue);
            //To update business information for the contact saved
            await this.contactDataService.getContactDetailsOffline(data, this.contactService.contactInformation);
            loader.dismiss();
            this.notificationService.notify(this.translate.instant('CONTACT_UPDATE_CREATED'), "ContactInfoComponent", "top", ToastStyle.INFO, 3000);
            data.eventsHandler(data.formValue,'NEWDATAUPDATED');
          }
          /*************Edit business information in offline - Non-OneKey contacts*************/
          else {
            if (!this.device.isOffline ){
            await this.contactDataService.createDynamicContact(data.formValue).then(async (res) => {
                if(res) {
                  if(res && res['contactid']) {
                    let rawDetails = await this.contactDataService.getContactDetails(this.contactService.contactInformation, true);

                    if(rawDetails) {
                      if(data && data.eventsHandler) {
                        this.events.publish("affilition:updated")
                        loader.dismiss();
                        this.notificationService.notify( this.translate.instant('CONTACT_UPDATE_CREATED'), "ContactInfoComponent", "top", ToastStyle.INFO, 3000);
                        data.eventsHandler(res,'NEWDATAUPDATED');
                      }
                    }
                  }
                  if(loader) loader.dismiss();
                }
            })
            .catch(async () => {
                loader.dismiss();
                data.eventsHandler("ERROR", 'NEWDATAUPDATED');
                 await this.disk.createOfflineContact(data.formValue);
            });
          } else {
            await this.disk.createOfflineContact(data.formValue);
          }
          }
        }
      } else if(eventTarget == 'CANCELBUTTONCLICK') {
        this.closePage((data && data.displayConfirmation));
      } else if(eventTarget == 'ADDEDLINKEDENTITY' || eventTarget == 'SCRAPLINKEDENTITY') {
        this.trackingService.tracking('DoneSelected', TrackingEventNames.CONTACT_EDIT, true);
        if(data && data.entity && data.values) {
          this.addLinkEntitiesForContact(data);
          this.dynamicFormsService.linkedEntityFormIsDirtyTracker = true;
        }
        //this.contactDataService.getContactDetails(this.contactService.contactInformation, true);
      } else if (eventTarget == 'ISFORMDIRTY') {
        // this.events.publish('addNewContacts', data);
      }
    }
  }

  private showConfirmationPopup(): Promise<any> {
    return new Promise(async (resolve, reject) => {
      return this.alertService.showAlert({
        title: this.translate.instant('POP_CONFIRM_SUBMIT_POLL'),
        message: this.translate.instant('R_U_SURE_SUBMIT_CR')
      }, this.translate.instant('CONFIRM'),  this.translate.instant('CANCEL')
      ).then(async res => {
        if (res.role === "ok") resolve(true);
        else reject();
      })
    })
  }

  private async _handleAddAccountAffiliationFormComponentEvent(data, eventTarget) {
    if (eventTarget) {
      if (eventTarget == 'DONEBUTTONCLICK') {
        if (data && data.formValue) {
          let payload = cloneDeep(data.formValue);
          const contact = this.contactService.contactInformation;
          payload['indskr_mdmrequesttype']= MDMRequestType.ADD_AFFILIATION;
          payload['indskr_mdmid'] = contact.indskr_mdmid;
          payload['indskr_lastname'] = contact.firstName;
          payload['indskr_gendercode'] = contact.gendercode === 1 ? OmniGender.MALE : OmniGender.FEMALE;
          const linkEntities = this.mdmService.getReqPayloadLinkEntities();
          data.formValue['lookupfields'].push({
            "name": "indskr_ContactCR",
            "entity": "indskr_contactcrs",
            "id": null
          })

          const customerSpecialtyId = await this.contactService.getCustomerSpecialtyId(contact.ID, contact.primarySpecialty?.id);
          payload['indskr_mdm'] = data.formValue['indskr_mdm'] ? data.formValue['indskr_mdm'] : 548910000;
          if (payload['indskr_mdm'] != 548910000) {

            if (data.formValue['indskr_mdm']) {
              delete data.formValue['indskr_mdm'];
            }
            payload["linkEntities"] = linkEntities;

            let account = null;
            if (this.businessLine === BusinessLineVal.PHARMA || this.businessLine === BusinessLineVal.VACCINE_MDM) {
              payload["lookupfields"] = [
                {
                  "name": "indskr_Specialty",
                 "entity": "indskr_lu_specialties",
                 "id": contact.primarySpecialty?.id
                }
              ]
            }
            payload['indskr_businessline'] = this.businessLine;
            let mdm_payload: any = this.getDefaultMDMEditPayload(payload, account);
            let shouldThrowEtmsErr = false;
            if (!isEmpty(linkEntities)) {
              linkEntities.forEach(e => {
                if (e['entity'] == "indskr_accountcontactaffiliationcrs") {
                  let values: [] = e['values'];
                  if (!isEmpty(values)) {
                    values.forEach(v => {
                      let lookupfields: [] = v['lookupfields'];
                      if (!isEmpty(lookupfields)) {
                        let acc = lookupfields.find(l => l['entity'] == 'accounts');
                        if (acc) {
                          account = this.accountService.getAccountById(acc['id']);
                          if (!account || !account.extendedDetails || !account.extendedDetails['externalId']) {
                            shouldThrowEtmsErr = true;
                            return;
                          }
                          payload['lookupfields'].push({
                            "name": "indskr_Account",
                            "entity": "accounts",
                            "id": acc['id']
                          });
                        }
                      }
                    })
                  }
                }
              })
            }
            if (shouldThrowEtmsErr) {
              this.notificationService.notify(this.translate.instant('ACCOUNT_ETMS_ERR_NOTIFY', { accountName: account.accountName }), 'DynamicFormComponent', "top", ToastStyle.INFO, 3000);
              return;
            }
            mdm_payload.new_hco_etms = account.raw['indskr_externalid'] ?account.raw['indskr_externalid'] : "";
            mdm_payload.new_hco_nm = account.accountName;
            mdm_payload.new_hco_vid = account.raw['indskr_hcovid'] ? account.raw['indskr_hcovid'] : "";
            this.mdmService.setNows(mdm_payload, this.businessLine);
            mdm_payload.new_hcp_first_nm = contact.firstName;
            mdm_payload.new_gender = contact.gendercode && contact.gendercode == 1 ? OneCRMGender.MALE : contact.gendercode == 2 ? OneCRMGender.FEMALE : '';
            mdm_payload.new_sa_dept_nm = "";
            mdm_payload.new_dept_nm = "";
            mdm_payload.dcr_type = OneCRMReqType.AFFILIATION;
            payload['mdm_payload'] = mdm_payload;
            payload['indskr_pharmarequesttype'] = 1;
            mdm_payload['new_hcp_etms'] = contact.indskr_externalid ? contact.indskr_externalid : "";
            if (this.businessLine === BusinessLineVal.PHARMA) {
              mdm_payload.dcr_business_line = BusinessLine.PHARMA;
              mdm_payload.new_title = contact.title ? contact.title : "";
              mdm_payload.new_position = data.formStringValue['indskr_rolepharma_Desc'] ? data.formStringValue['indskr_rolepharma_Desc'] : data.formStringValue['indskr_rolepharma'];
              mdm_payload.new_specialty = contact.primarySpecialty ? contact.primarySpecialty.name : "";
            } else if(this.businessLine === BusinessLineVal.VACCINE_MDM) {
              mdm_payload.dcr_business_line = BusinessLine.VACCINE;
              mdm_payload.new_title = contact.title ? contact.title : "";
              mdm_payload.new_position = data.formStringValue['indskr_rolepharma_Desc'] ? data.formStringValue['indskr_rolepharma_Desc'] : data.formStringValue['indskr_rolepharma'];
              mdm_payload.new_specialty = contact.primarySpecialty ? contact.primarySpecialty.name : "";
            } else {
              mdm_payload.dcr_business_line = BusinessLine.REATIL;
              mdm_payload.new_position = data.formStringValue['indskr_positionretail_Desc'] ? data.formStringValue['indskr_positionretail_Desc'] : data.formStringValue['indskr_positionretail'];
              mdm_payload.new_specialty = "";
              mdm_payload.new_title = data.formStringValue['indskr_titleretail_Desc'] ? data.formStringValue['indskr_titleretail_Desc'] : data.formStringValue['indskr_titleretail'];
            }
          }
          if (!await this.showConfirmationPopup()) return;
          await this.uiService.displayLoader();
          if (payload) {
            if (this.device.isOffline) {

              this._createOneKeyCRId(payload);

              this.contactDataService.addToOfflineOneKeyCRIds(payload.addedNewOneKeyCRId);

              if (payload.addedNewOneKeyCRId) {
                payload['statuscode'] = ChangeRequestStatusCode.IN_PROGRESS;
                payload['statecode'] = ChangeRequestStateCode.INACTIVE;
              }

              await this.disk.createOneKeyCR(payload);
              data.eventsHandler(payload, 'DISABLEFORM');
              data.eventsHandler(data.formValue,'NEWDATAUPDATED');
              this._showContactsCRStagedNotification(payload);
            } else{
              await this.createOneKeyContactCR(payload, data).then((created) => {
                if (created) this._showContactsCRStagedNotification(payload);
              });
            }
          }
          await this.uiService.dismissLoader();
        }
      } else if (eventTarget == 'CANCELBUTTONCLICK') {
        this.closePage((data && data.displayConfirmation));
      } else if (eventTarget == 'ADDEDLINKEDENTITY') {
        if (data) {
          this.mdmService.addLinkEntities(data);
          this.dynamicFormsService.linkedEntityFormIsDirtyTracker = true;
          if (data && data.eventsHandler) {
            data.eventsHandler(data, 'ENABLEFORM');
          }
        }
      } else if (eventTarget == 'ISFORMDIRTY') {
        // this.events.publish('addNewContacts', data);
      }
    }
  }

  private async _handleOneKeyContactFormComponentEvent(data, eventTarget){
    if(eventTarget){
      if(eventTarget == 'DONEBUTTONCLICK'){
        if (data && data.formValue) {

          let payload = cloneDeep(data.formValue);
          payload['indskr_mdmrequesttype'] = MDMRequestType.UPDATE;
          payload['indskr_mdmid'] = this.contactService.contactInformation.indskr_mdmid;
          payload["linkEntities"] = this.mdmService.getReqPayloadLinkEntities();

          if (!await this.showConfirmationPopup())  return;
          payload['indskr_mdm'] = data.formValue['indskr_mdm'] ? data.formValue['indskr_mdm'] : 548910000;
          if (payload['indskr_mdm'] != 548910000) {

            let account = null;
            if (data.formValue.lookupfields && data.formValue.lookupfields.length) {
              let accountLookup = data.formValue.lookupfields.filter(e => e.name == "indskr_Account");
              if (!isEmpty(accountLookup)) {
                account = this.accountService.getAccountById(accountLookup[0].id);
              }
              if (!account || !account.extendedDetails || !account.extendedDetails['externalId']) {
                this.notificationService.notify(this.translate.instant('ACCOUNT_ETMS_ERR_NOTIFY', { accountName: (account && account.accountName) ? account.accountName : "" }), 'DynamicFormComponent', "top", ToastStyle.INFO, 3000);
                return;
              }
            }

            payload['indskr_businessline'] = this.businessLine;
            let mdm_payload: any = this.getDefaultMDMEditPayload(payload, account);
            mdm_payload.new_hco_etms = account.raw['indskr_externalid'] ?account.raw['indskr_externalid'] : "";
            mdm_payload.new_hco_nm = account.accountName;
            mdm_payload.new_hco_vid = account.raw['indskr_hcovid'] ? account.raw['indskr_hcovid'] : "";
            this.mdmService.setNows(mdm_payload, this.businessLine);
            mdm_payload.new_hcp_first_nm = `${payload['indskr_lastname']}`;
            mdm_payload.new_gender = payload['indskr_gendercode'] == OmniGender.MALE ? OneCRMGender.MALE : OneCRMGender.FEMALE;
            mdm_payload.new_hcp_first_nm = `${payload['indskr_lastname']}`;
            if (this.businessLine === BusinessLineVal.PHARMA || this.businessLine === BusinessLineVal.RETAIL || this.businessLine === BusinessLineVal.VACCINE_MDM) {
              if (this.businessLine === BusinessLineVal.PHARMA) {
                mdm_payload.dcr_business_line = BusinessLine.PHARMA;
                mdm_payload.new_position = data.formStringValue['indskr_rolepharma_Desc'] ? data.formStringValue['indskr_rolepharma_Desc'] : data.formStringValue['indskr_rolepharma'];
                mdm_payload.new_specialty = data.formStringValue['indskr_specialty'];
                mdm_payload.new_title = data.formStringValue['indskr_titlepharma_Desc'] ? data.formStringValue['indskr_titlepharma_Desc'] : data.formStringValue['indskr_titlepharma'];
              } else if(this.businessLine === BusinessLineVal.VACCINE_MDM) {
                mdm_payload.dcr_business_line = BusinessLine.VACCINE;
                mdm_payload.new_position = data.formStringValue['indskr_rolepharma_Desc'] ? data.formStringValue['indskr_rolepharma_Desc'] : data.formStringValue['indskr_rolepharma'];
                mdm_payload.new_specialty = data.formStringValue['indskr_specialty'];
                mdm_payload.new_title = data.formStringValue['indskr_titlepharma_Desc'] ? data.formStringValue['indskr_titlepharma_Desc'] : data.formStringValue['indskr_titlepharma'];
              } else {
                mdm_payload.dcr_business_line = BusinessLine.REATIL;
                mdm_payload.new_position = data.formStringValue['indskr_positionretail_Desc'] ? data.formStringValue['indskr_positionretail_Desc'] : data.formStringValue['indskr_positionretail'];
                mdm_payload.new_specialty = "";
                mdm_payload.new_title = data.formStringValue['indskr_titleretail_Desc'] ? data.formStringValue['indskr_titleretail_Desc'] : data.formStringValue['indskr_titleretail'];
              }
              mdm_payload.new_dept_nm = "";
              mdm_payload['new_sa_dept_nm'] = "";
              if (data.formValue.lookupfields && data.formValue.lookupfields.length) {
                let specialty = data.formValue.lookupfields.find(e => e['entity'] == "indskr_lu_specialties");
                if (specialty) {
                  let sp = this.contactService.specialties.find(e => e.id == specialty.id);
                  if (sp) {
                    mdm_payload['new_sa_dept_nm'] = sp.indskr_sadeptnm ? sp.indskr_sadeptnm : "";
                  }
                }
              }
              payload['mdm_payload'] = mdm_payload;
              payload['indskr_pharmarequesttype'] = 2;
            } else {
              mdm_payload.dcr_business_line = BusinessLine.VACCINE;
              mdm_payload.new_position = data.formStringValue['indskr_rolevaccine_Desc'] ? data.formStringValue['indskr_rolevaccine_Desc'] : data.formStringValue['indskr_rolevaccine'];
              mdm_payload.new_dept_nm = data.formStringValue['indskr_departmentvaccine_Desc'] ? data.formStringValue['indskr_departmentvaccine_Desc'] : data.formStringValue['indskr_departmentvaccine'];
              mdm_payload.new_specialty = "";
              mdm_payload.new_sa_dept_nm = "";
              mdm_payload.new_title = "";
              mdm_payload.new_hcp_auth = true;
              mdm_payload.now_hcp_auth = true;
              payload['mdm_payload'] = mdm_payload;
              payload["lookupfields"].push(
                {
                  "name": "indskr_Contact",
                  "entity": "contacts",
                  "id": this.contactService.contactInformation.ID
                })
            }
          }
          await this.uiService.displayLoader();
          if (payload) {
            if (!this.device.isOffline) {
              await this.createOneKeyContactCR(payload, data).then((created) => {
                if (created) this._showContactsCRStagedNotification(payload);
              });
            } else {
              // Save the Payload offline
              this._createOneKeyCRId(payload);

              this.contactDataService.addToOfflineOneKeyCRIds(payload.addedNewOneKeyCRId);

              if (payload.addedNewOneKeyCRId) {
                payload['statuscode'] = ChangeRequestStatusCode.IN_PROGRESS;
                payload['statecode'] = ChangeRequestStateCode.INACTIVE;
              }

              await this.disk.createOneKeyCR(payload);

              // Update CR list
              payload['modifiedon'] = new Date().getTime();
              payload['createdon'] = new Date().getTime();
              await this.mdmService.fetchOneKeyCRConfiguredDisplayOffline(payload, payload['linkEntities']);
              let contactCRs = this.mdmService.contactCRs.getValue();
              contactCRs.push(payload);
              this.mdmService.contactCRs.next(contactCRs);
              this.mdmService.contactCRList = contactCRs;

              data.eventsHandler(payload, 'DISABLEFORM');
              await this._saveContactCRStagedNotification(payload, data);
              data.eventsHandler(data.formValue,'NEWDATAUPDATED');
              this._showContactsCRStagedNotification(payload);
            }
          }
          await this.uiService.dismissLoader();
        }
      } else if(eventTarget == 'CANCELBUTTONCLICK') {
        this.closePage((data && data.displayConfirmation));
      } else if(eventTarget == 'ADDEDLINKEDENTITY') {
        if (data) {
          this.dynamicFormsService.linkedEntityFormIsDirtyTracker = true;
          this.mdmService.addLinkEntities(data);
          if (data && data.eventsHandler) {
            data.eventsHandler(data, 'ENABLEFORM');
          }
        }
      } else if (eventTarget == 'ISFORMDIRTY') {
        // this.events.publish('addNewContacts', data);
      }
    }
  }

  private async _handleChangeRequestCategoryFlow(data, eventTarget) {
    if (this.device.isOffline) {
      this.notificationService.notify(this.translate.instant('DEVICE_NEEDS_TO_BE_ONLINE_TO_CREATE_CHANGE_REQUEST'), 'ContactInfoComponent', "top", ToastStyle.DANGER, 3000);
      return;
    }
    if (eventTarget) {
      if (eventTarget == 'DONEBUTTONCLICK') {
        const hasLinkEntities = this.mdmService.getReqPayloadLinkEntities()?.length > 0;
        const hasFormValue = data && data.formValue && Object.keys(data.formValue).length > 0;
        if (data && (hasFormValue || hasLinkEntities || data.formValue)) {
          let payload = data.formValue ? cloneDeep(data.formValue) : {};
          payload['indskr_firstname'] = this.contactService.contactInformation.firstName;
          payload['indskr_lastname'] = this.contactService.contactInformation.lastName;
          payload['indskr_middlename'] = this.contactService.contactInformation.middleName;
          if (this.selectedChangeRequestCategoryId) {
            // Append the category/contact lookups to the lookups the form already
            // collected (e.g. Primary Specialty). Overwriting here would discard every
            // lookup the user selected on the form and only submit these two.
            payload['lookupfields'] = [
              ...(payload['lookupfields'] || []),
              {
                'name': 'indskr_ChangeRequestType',
                'entity': 'indskr_expertcategorieses',
                'id': this.selectedChangeRequestCategoryId
              },
              {
                "name": "indskr_Contact",
                "entity": "contacts",
                "id": this.contactService.contactInformation.ID
              }
            ];
          }

          payload["linkEntities"] = this.mdmService.getReqPayloadLinkEntities();
          const noseeflagValue = this.contactService.contactInformation.raw?.exe_noseeflag1;
          const deletereasonValue = this.contactService.contactInformation.raw?.exe_deletereason;
          if (this.currentChangeRequestFormId?.includes("Exeltis Delete CR Form")) {
            if (noseeflagValue !== undefined && noseeflagValue !== null) {
              payload['exe_noseeflag'] = noseeflagValue;
            }
            if (deletereasonValue !== undefined && deletereasonValue !== null) {
              payload['exe_deletereason'] = deletereasonValue;
            }

            if (payload['exe_noseeflag_new'] === true && payload['exe_deletereason_new'] == 791060003) {
              this.addRemovedPositionLinkEntity(payload, this.authService.user.positionID);
            }
          } else {
            if (noseeflagValue !== undefined && noseeflagValue !== null) {
              payload['exe_noseeflag_new'] = noseeflagValue;
            }
            if (deletereasonValue !== undefined && deletereasonValue !== null) {
              payload['exe_deletereason_new'] = deletereasonValue;
            }
          }

          // Add user's current customer position to linkEntities as removed for Exeltis Realignment CR Form
          if (this.currentChangeRequestFormId?.includes("Exeltis Realignment CR Form") && this.dynamicFormsService.removedCustomerPositionForRealignment) {
            this.addRemovedPositionLinkEntity(payload, this.dynamicFormsService.removedCustomerPositionForRealignment);
            this.dynamicFormsService.removedCustomerPositionForRealignment = null;
          }

          if (!await this.showConfirmationPopup()) return;

          await this.uiService.displayLoader();
          if (payload) {
            if (!this.device.isOffline) {
              await this.createOneKeyContactCR(payload, data, true, true).then((created) => {
                if (!created) return;
                // Reset the form dirty state after a successful save so navigating
                // back does not prompt the discard-changes confirmation (createOneKeyContactCR
                // only fires DISABLEFORM; NEWDATAUPDATED clears the remaining dirty trackers).
                if (data && data.eventsHandler) {
                  data.eventsHandler(data.formValue, 'NEWDATAUPDATED');
                }
                this.notificationService.notify(this.translate.instant('THE_CHANGE_REQUEST_HAS_BEEN_SUBMITTED'), 'ContactInfoComponent', "top", ToastStyle.INFO, 3000);
              });
            } else {
              // Save the Payload offline
              this._createOneKeyCRId(payload);

              this.contactDataService.addToOfflineOneKeyCRIds(payload.addedNewOneKeyCRId);

              if (payload.addedNewOneKeyCRId) {
                payload['statuscode'] = ChangeRequestStatusCode.IN_PROGRESS;
                payload['statecode'] = ChangeRequestStateCode.INACTIVE;
              }

              await this.disk.createOneKeyCR(payload);

              // Update CR list
              payload['modifiedon'] = new Date().getTime();
              payload['createdon'] = new Date().getTime();
              await this.mdmService.fetchOneKeyCRConfiguredDisplayOffline(payload, payload['linkEntities']);
              let contactCRs = this.mdmService.contactCRs.getValue();
              contactCRs.push(payload);
              this.mdmService.contactCRs.next(contactCRs);
              this.mdmService.contactCRList = contactCRs;

              data.eventsHandler(payload, 'DISABLEFORM');
              data.eventsHandler(data.formValue, 'NEWDATAUPDATED');
              this.notificationService.notify(this.translate.instant('THE_CHANGE_REQUEST_HAS_BEEN_SUBMITTED'), 'ContactInfoComponent', "top", ToastStyle.INFO, 3000);
            }
          }
          await this.uiService.dismissLoader();
        }
      } else if (eventTarget == 'CANCELBUTTONCLICK') {
        this.closePage((data && data.displayConfirmation));
      } else if (eventTarget == 'ADDEDLINKEDENTITY') {
        if (data) {
          this.dynamicFormsService.linkedEntityFormIsDirtyTracker = true;
          const editedDataId = data.linkedEntityExistingDataId || data.linkedEntityExistingDataAddressId || data.linkedEntityAddedNewDataId;
          const linkEntities = (this.mdmService.getReqPayloadLinkEntities() as any[]) || [];
          const existingLinkedEntity = linkEntities.find((e: any) => e.entity === data.entity && editedDataId == e.id);
          const supportsExeType = this.categoryFlowEntitySupportsExeType(data.entity);
          if (existingLinkedEntity) {
            // Preserve exe_type from existing values by index
            const existingExeTypes = existingLinkedEntity.values?.map((val: any) => val.exe_type) || [];
            existingLinkedEntity.values = data.values;
            // Restore exe_type for each item if it existed
            existingLinkedEntity.values?.forEach((val: any, index: number) => {
              if (existingExeTypes[index] !== undefined) {
                val.exe_type = existingExeTypes[index];
              }
            });
          } else {
            if (supportsExeType) {
              data.values.forEach(value => {
                value['exe_type'] = data.linkedEntityExistingDataId || data.linkedEntityExistingDataAddressId ? 791060001 : 791060000;
              });
            }
            this.mdmService.addLinkEntities(data, editedDataId);
          }
          if (data && data.eventsHandler) {
            data.eventsHandler(data, 'ENABLEFORM');
          }
        }
      } else if (eventTarget == 'ISFORMDIRTY') {
      } else if (eventTarget == "SCRAPLINKEDENTITY") {
        const linkEntities = (this.mdmService.getReqPayloadLinkEntities() as any[]) || [];
        const id = data.linkedEntityExistingDataId || data.linkedEntityAddedNewDataId || data.linkedEntityExistingDataAddressId;
        const existingLinkedEntity = linkEntities.find((e: any) => e.entity === data.entity && id == e.id);
        const supportsExeType = this.categoryFlowEntitySupportsExeType(data.entity);
        if (existingLinkedEntity) {
          if (supportsExeType) {
            existingLinkedEntity.values.forEach(value => {
              value.exe_type = 791060002;
            });
          }
        } else {
          const lookupfields = [];
          if (data.values?.contactCRLookupField) {
            lookupfields.push(data.values.contactCRLookupField);
          }

          // For non-exe_customerlicensechangerequests, add entity-specific lookup field
          if (data.entity !== 'exe_customerlicensechangerequests') {
            const { lookUpEntityName, schemaName } = this._getLinkedEntityLookupInfo(data.entity);
            lookupfields.unshift({
              "name": schemaName,
              "entity": lookUpEntityName,
              "id": id
            });
          }

          if (lookupfields.length > 0) {
            const valueObj: any = {
              'lookupfields': lookupfields
            };
            if (supportsExeType) {
              valueObj['exe_type'] = 791060002;
            }

            // Special handling for exe_customerlicensechangerequests
            if (data.entity === 'exe_customerlicensechangerequests') {
              valueObj['exe_sln_new'] = id;
            }

            data.values = [valueObj];
          }
          this.mdmService.addLinkEntities(data);
        }
        if (data && data.eventsHandler) {
          data.eventsHandler(data, 'ENABLEFORM');
        }
      }
    }
  }

  /**
   * `exe_type` is an Exeltis-publisher CR lifecycle marker (create/update/remove). It only exists
   * as an attribute on CR child entities in tenants where the Exeltis solution is installed. On
   * non-Exeltis tenants the attribute does not exist, so stamping it on the submit payload makes
   * Dynamics reject the whole change request (OMNI-60618).
   *
   * The gate is intentionally OR'd so Exeltis behaviour is left byte-for-byte unchanged (and needs
   * no Exeltis-tenant re-test):
   *   - Exeltis CR forms are named "Exeltis ..." (the codebase already keys behaviour off this name,
   *     see the delete/realignment/shared-target form checks). For those, exe_type is always stamped
   *     for every CR child entity, exactly as before.
   *   - Otherwise, fall back to the form's actual schema: stamp only when the CR subgrid layout
   *     declares an `exe_type` column (i.e. the CR entity genuinely has the attribute). This is what
   *     spares non-Exeltis tenants the rejected submit.
   */
  private categoryFlowEntitySupportsExeType(entitySetName: string): boolean {
    const isExeltisForm = !!this.currentChangeRequestFormId && this.currentChangeRequestFormId.includes('Exeltis');

    const controls = this.currentChangeRequestCategoryForm?.metadata?.flatMap(section => section.controls || []) || [];
    const control = controls.find(c => c.lookupEntitySetName === entitySetName);
    const subgridLayout = control?.subgrid?.subgridLayout || [];
    const layoutDeclaresExeType = subgridLayout.some(attrib => {
      const attribute: string = attrib?.attribute || '';
      const separatorIndex = attribute.indexOf('.');
      const attribName = separatorIndex !== -1 ? attribute.slice(separatorIndex + 1) : attribute;
      return attribName === 'exe_type';
    });

    return isExeltisForm || layoutDeclaresExeType;
  }

  private _getLinkedEntityLookupInfo(entity: string): { lookUpEntityName: string; schemaName: string } {
    let lookUpEntityName = '';
    let schemaName = '';

    if (entity === 'indskr_addresscrs') {
      lookUpEntityName = "indskr_addresses";
      schemaName = 'exe_Address';
    } else if (entity === 'indskr_customerspecialtychangerequests') {
      lookUpEntityName = "indskr_customerspecialties";
      schemaName = 'exe_Specialty_New';
    } else if (entity === 'exe_customerpositionchangerequests') {
      lookUpEntityName = "positions";
      schemaName = 'exe_Position_New';
    } else if (entity === 'exe_customerdegreechangerequests') {
      lookUpEntityName = "indskr_degrees";
      schemaName = 'exe_Degree';
    }

    return { lookUpEntityName, schemaName };
  }

  private _createOneKeyCRId(payload: any) {
    const addedNewOneKeyCRId = 'onekeycr' + '_' + Math.random().toString(36).substring(7);

    if (this.contactDataService.isOfflineOneKeyCR(addedNewOneKeyCRId)) {
      payload['addedNewOneKeyCRId'] = addedNewOneKeyCRId;
      payload['indskr_contactcrid'] = addedNewOneKeyCRId;
    }
  }

  private _showContactsCRStagedNotification(payload: any) {
    if (payload['indskr_mdm'] == BusinessProcessType.SanofiChina) {
      this.notificationService.notify(this.translate.instant('ONECRM_DCR_CHANGE_REQUEST_IN_PROCESS'), 'DynamicFormComponent', "top", ToastStyle.INFO, 3000);
    } else {
      this.notificationService.notify(this.translate.instant('ONE_KEY_CHANGE_REQUEST_IN_PROCESS'), 'DynamicFormComponent', "top", ToastStyle.INFO, 3000);
    }
  }

  private async createOneKeyContactCR(payload: any, data: any, exeevoCr: boolean = false, skipStagedNotification: boolean = false): Promise<boolean> {
    if (this.device.isOffline) return false;
    // Lock the form before the round trip so the rep can't edit or resubmit while it runs.
    data?.eventsHandler?.(data, 'DISABLEFORM');
    let created = false;
    await this.mdmService.createOneKeyContactCR(payload, exeevoCr).then(async (res) => {
      try {
        if (res && res['indskr_contactcrid']) {
          created = true;
          if (res.hasOwnProperty('indskr_isduplicate') && res['indskr_isduplicate']) {
            this.notificationService.notify(this.translate.instant('CRM_DUP_CR_ERR'), 'DynamicFormComponent', "top", ToastStyle.INFO, 3000);
          }

          if (data && data.eventsHandler) {
            data.eventsHandler(res, 'DISABLEFORM');
            this.dynamicFormsService.linkedEntityFormIsDirtyTracker = false;
            if (!skipStagedNotification) {
              this.notificationService.notify(this.translate.instant('CR_UPDATE_SUBMIT_MESSAGE', { crType: this.utilityService.globalCustomerText.toLowerCase(), lastName: payload['indskr_lastname'] }), 'Contact-Form-Component');
            }
            if (this.authService.okIntegrationSettings && this.authService.okIntegrationSettings.typeOfIntegration == IntegrationType.ONE_KEY) {

              await this.mdmService.addNotification(data, res, NOTIFICATION.ONE_KEY_CHNAGE_REQUEST_UPDATE_REQUEST_SUBMITTED, this.translate.instant('ONE_KEY_CHNAGE_REQUEST_UPDATE_REQUEST_SUBMITTED',
                { fullname: data.formValue['indskr_firstname'] + " " + data.formValue['indskr_lastname'] }), 'Submitted');
            } else if (!skipStagedNotification) {
              await this._saveContactCRStagedNotification(payload, data, res);
            }
          }

          // Not awaited: an extra server read must not hold back the submitted toast.
          void this._refreshContactAfterApprovedCR(res);
        }
      } catch (error) {
        console.error(error);
        throw error;
      }
    }).catch((err) => {
        if(err.error) {
          if (err.error.error && err.error.error == 'MDM_DCR_CREATION_FAILED') {
            this.notificationService.notify(this.translate.instant('ONECRM_DCR_CHANGE_REQUEST_FAILED'), 'DynamicFormComponent', "top", ToastStyle.INFO, 3000);
          } else if (err.error.errorMessage && err.error.errorMessage.includes('Contact CR already exists')) {
            this.notificationService.notify(this.translate.instant('CRM_DUP_CR_ERR'), 'DynamicFormComponent', "top", ToastStyle.INFO, 3000);
          } else if (err.error.message && err.error.message.includes('Contact CR already exists')) {
            this.notificationService.notify(this.translate.instant('CRM_DUP_CR_ERR'), 'DynamicFormComponent', "top", ToastStyle.INFO, 3000);
          } else if (err.error.errorMessage && err.error.errorMessage.includes('Contact already exists')) {
            this.notificationService.notify(this.translate.instant('CRM_DUP_CONTACT_ERR'), 'DynamicFormComponent', "top", ToastStyle.INFO, 3000);
          }
        }
        if (!created) data?.eventsHandler?.(data, 'SUBMITFAILED');
        this.uiService.dismissLoader();
        throw err;
      });
    if (!created) data?.eventsHandler?.(data, 'SUBMITFAILED');
    return created;
  }

  /**
   * Re-reads the contact after a change request was created, so an auto-approved
   * request shows up on the display form straight away.
   *
   * Dynamics applies an auto-approved CR to the contact during the create call,
   * so the server copy is already current when the response comes back. Nothing
   * on the client re-reads it though: opening a contact that is already in the
   * rep's position serves the cached record (only the global-search and
   * newly-added paths call getContactDetails), so the edit stayed invisible
   * until the next delta sync.
   *
   * The CR status is taken from the create response. A response that explicitly
   * reports a pending status is left alone - the contact genuinely has not
   * changed until an approver acts. When the response carries no status we
   * cannot tell, so we refresh anyway: one redundant read costs less than
   * showing the rep stale data.
   */
  private async _refreshContactAfterApprovedCR(res: any): Promise<void> {
    if (this.device.isOffline || !this.contactService.contactInformation) return;
    const PENDING_STATUSES = [
      ChangeRequestStatusCode.OPEN,
      ChangeRequestStatusCode.IN_PROGRESS,
      ChangeRequestStatusCode.SUBMITTED,
      ChangeRequestStatusCode.PENDING_APPROVAL,
    ];
    const status = res ? res['statuscode'] : undefined;
    if (status !== undefined && status !== null && PENDING_STATUSES.includes(status)) return;
    try {
      await this.contactDataService.getContactDetails(this.contactService.contactInformation, true);
    } catch (error) {
      // A failed refresh must not fail the submit: the CR was created, and delta
      // sync still reconciles the contact.
      console.error('_refreshContactAfterApprovedCR: contact refresh failed', error);
    }
  }

  private async _saveContactCRStagedNotification(payload: any, data: any, res?: any) {
    if (payload['indskr_mdm'] == BusinessProcessType.SanofiChina) {
      await this.mdmService.addNotification(data, res, NOTIFICATION.ONECRM_UPDATE_DCR_REQUEST_STAGED, this.translate.instant('ONECRM_UPDATE_DCR_REQUEST_STAGED',
        { fullname: data.formValue['indskr_lastname'] }), 'Submitted');
    } else {
      await this.mdmService.addNotification(data, res ?? data, NOTIFICATION.ONE_KEY_CHANGE_REQUEST_UPDATE_STAGED, this.translate.instant('ONE_KEY_CHANGE_REQUEST_UPDATE_STAGED',
        { fullname: data.formValue['indskr_firstname'] + " " + data.formValue['indskr_lastname'] }), 'Submitted');
    }
  }

  private getDefaultMDMEditPayload(payload: any, account: any): any {
    let userEmail = this.authService.user.mail;
    if (userEmail.includes('sanofi.net.cn'))
      userEmail = userEmail.replace('sanofi.net.cn', 'sanofi.com');
    return {
      "dcr_source": DCR_SOURCE.ONECRM,
      "dcr_requestor_staff_cd": null,
      "dcr_requestor_nm": this.authService.user.displayName,
      "dcr_requestor_email": userEmail,
      "dcr_category": DCR_CATEGORY.HCP,
      "dcr_type": OneCRMReqType.UPDATE,
      "new_hcp_status": "ACTV",
      "new_hcp_auth": ""
    };
  }

  closePage(isCancel?: boolean) {
    if(isCancel) {
        let cancelText = this.translate.instant("CANCEL");
        if(this.translate.currentLang == 'it') {
          cancelText = this.translate.instant("CANCEL_BUTTON_DISCARD_CHANGE");
        }
        this.alertService.showAlert({
            title: this.translate.instant('SCHEDULER_LIST_ALERT_TITLE'),
            message: this.translate.instant('CONTACT_R_U_WANT_CANCEL_LOSE_CHANGES')}, this.translate.instant('DISCARD_CONTACT_CR'), cancelText
        ).then (res => {
            if(res.role == "ok") {
                this.dynamicFormsService.okLookUpMapper = [];
                this.trackingService.tracking('DiscardSelected', TrackingEventNames.CONTACT_EDIT, true);
                this.uiService.showNewActivity= false;
                this.navService.popChildNavPageWithPageTracking();
            } else {
              this.trackingService.tracking('CancelSelected', TrackingEventNames.CONTACT_EDIT, true);
            }
        });
    } else {
        this.trackingService.tracking('CancelSelected', TrackingEventNames.CONTACT_EDIT, true);
        this.uiService.showNewActivity= false;
        this.navService.popChildNavPageWithPageTracking();

    }
  }

  public async updateNote(ev) {

    if (ev && ev.action) {
      const idx = this.currentCustomerNotes.findIndex(note => note.noteId == ev.noteId);
      if (idx < 0) {
        console.error("Error : coundn't find note id --> ", ev.noteId);
        return
      }
      let existingNote = this.currentCustomerNotes[idx];
      let offlinePayload: any = {
        annotationid: existingNote.noteId,
        contactid: existingNote.contactId,
        createdon: existingNote.createdTime.getTime().toString(),
        notetext: existingNote.noteText,
        ownerName: existingNote.ownerName,
        ownerid: existingNote.ownerId,
        isdocument: existingNote.hasDocument,
        filename: existingNote.documentName,
        mimetype: existingNote.documentMimeType,
        filesize: existingNote.documentSize,
        pendingPushOnDynamics: true
      };
      if (existingNote.noteId.includes("offlinecustomernote") && existingNote.hasDocument && !isEmpty(existingNote.documentDataURL)) {
        offlinePayload.documentbody = existingNote.documentDataURL;
      }
      if (ev.action == 'DELETE' && idx >= 0) {
        offlinePayload.deleted = true;
        this.currentCustomerNotes.splice(idx, 1);
      } else if (ev.action == 'SAVE' && idx >= 0) {
        this.currentCustomerNotes[idx].noteText = offlinePayload.notetext = ev.updatedText
        if (ev.attachmentFileUpdated) {
          this.currentCustomerNotes[idx].hasDocument = offlinePayload['isdocument'] = true;
          offlinePayload['documentbody'] = ev.attachmentFileDataUrl;
          this.currentCustomerNotes[idx].documentName = offlinePayload['filename'] = ev.documentName;
          this.currentCustomerNotes[idx].documentSize = offlinePayload['filesize'] = ev.documentSize;
          this.currentCustomerNotes[idx].documentMimeType = offlinePayload['mimetype'] = ev.documentMimeType;
          offlinePayload['fileupdated'] = true;
        }
        if (ev.isAttachmentRemoved) {
          this.currentCustomerNotes[idx].hasDocument = offlinePayload['isdocument'] = false;
          this.currentCustomerNotes[idx].documentMimeType = this.currentCustomerNotes[idx].documentName = '';
          offlinePayload['documentbody'] = offlinePayload['filename'] = offlinePayload['filesize'] = offlinePayload['mimetype'] = '';
          offlinePayload['fileremoved'] = true;
        }
      }
      const loader = await this.loadingCtrl.create();
      loader.present();
      // Update Service
      this._sortCustomerNotes();
      await this.contactDataService.updateCustomerNoteInOfflineDB(offlinePayload);
      if (!this.device.isOffline) {
        await this.contactDataService.uploadCustomerNotesOnline().then(res => {
          // Look up by id, not idx: the upload's save reloads currentCustomerNotes (contactNotesUpdated).
          const savedNote = this.currentCustomerNotes.find(note => note.noteId == existingNote.noteId);
          if (savedNote && ev.action != 'DELETE' && res && Array.isArray(res) && res.length > 0 && res[0].noteid) {
            savedNote.noteId = res[0].noteid;
          }
        });
      }
      loader.dismiss();
    }
  }

  public isNoteControlsEnabled(note: IONote): boolean {
    return !!(note.ownerId == this.authService.user.systemUserID);
  }

  private initBusinessRules(contactForm: DynamicForm) {
    try {
      if (!this.rawFormData) return;
      const noConsent = this.rawFormData.omniveev_pdrpoptout === PdrpOptOutStatus.OptedOut && this.dateTimeFormatsService.isPastDate(this.rawFormData.omniveev_pdrpoptoutdate);
      const rxRestricted = !!this.rawFormData.indskr_restrictrxsalesdataaccess;
      const hideRxData = noConsent || rxRestricted;
      if (hideRxData) {
        this.rawFormData.RxSalesData_NoConsentMessage = this.translate.instant('RX_TRENDS_RESTRICTED');
      }
      for (const tab of contactForm.metadata) {
        for (const control of tab.controls) {
          if (control.attributeName === 'SalesDataSubGrid') {
            control.isVisible = !hideRxData;
            control.forceHide = hideRxData;
          }
          if ((control.displayNames || [])[0]?.description === 'RxSalesData_NoConsentMessage') {
            control.isVisible = hideRxData;
            if (control.isVisible) {
              control.displayNames[0].description = '';
              control.dataType = ControlDataType.StringType;
              control.attributeName = 'RxSalesData_NoConsentMessage';
              control.isReadOnly = true;
            }
          }
        }
      }
    } catch (ex) {
      console.error('Unable to init business rules', ex);
    }
  }

  /**
   * contactform.affiliatedAccountsOnline = "all": replace the position-scoped account-affiliation rows with the
   * complete live list for this contact. Rows are handed to ind-display-form in memory and
   * never stored, so this costs one request per contact open and nothing on sync.
   */
  private async _loadAllAffiliatedAccounts() {
    if (this.authService.getAffiliationVisibility().contactForm.affiliatedAccountsOnline !== 'all') return;

    const contact = this.contactService.contactInformation;
    if (!contact) return;

    const rows = await this.contactService.fetchAllAffiliatedAccountsForContact(contact.ID);
    // null means offline or the request failed - keep whatever local storage supplied.
    if (!rows) return;
    if (this.contactService.contactInformation?.ID !== contact.ID) return;

    const existingInMemory = this.contactService.contactInformation.raw?.['globalSearchedDataLinkEntities'] ?? {};
    const marked = this._markAffiliatedAccounts(rows);
    this.rawFormData = {
      ...this.contactService.contactInformation.raw,
      globalSearchedDataLinkEntities: {
        ...existingInMemory,
        [ACCOUNT_CONTACT_AFFILIATIONS_REF_ENTITY]: marked,
      },
    };
    // So the Affiliation Explorer opens on these rows, and so the glance card re-evaluates
    // the Explorer button - this loader is not awaited and finishes after it was built.
    this.contactService.publishBeyondPositionAffiliations(contact.ID, { [ACCOUNT_CONTACT_AFFILIATIONS_REF_ENTITY]: marked });
    this.events.publish('refreshContactDetailGlanceData');
    this._cd.markForCheck();
  }

  /**
   * Accounts the rep owns first, then the rest. Ownership is resolved once per row into a
   * Set because AccountOfflineService.getAccountById is a linear scan over every account.
   */
  private _markAffiliatedAccounts(rows: any[]): any[] {
    const accountIdKey = ACCOUNT_CONTACT_AFFILIATIONS_REF_ENTITY + '.indskr_accountid';
    const myAccountIds = new Set<string>((this.accountService.accounts ?? []).map(a => a.id));

    rows.forEach(row => {
      const accountId = row?.[accountIdKey];
      row[OUTSIDE_TERRITORY_ROW_KEY] = !!accountId && !myAccountIds.has(accountId);
    });

    return rows;
  }

  private async initContactInfo() {
    if (this.contactService.contactInformation) {
      let contactForm: DynamicForm = await this.dynamicFormsService.getFormDefinitionForEntity("contact", FormType.DISPLAYFORM);
      let formType = DynamicFormType.CONFIGUREDFORM;
      if (!contactForm) {
        contactForm = new DynamicForm(DEFAULT_CONTACT_DISPLAY_FORM['value'][0]);
        formType = DynamicFormType.DEFAULTFORM;
      }
      if (this.authService.hasFeatureAction(FeatureActionsMap.CUSTOMER_LIST_MANAGEMENT)) {
        const listPeriodTags = this.territoryService.getListPeriodTags();
        this.contactService.contactInformation.raw['tagLabels'] = this.contactService.contactInformation.raw['tagLabels'] ? this.contactService.contactInformation.raw['tagLabels'].filter(tag => listPeriodTags.includes(tag)) : [];
        const index = contactForm.metadata[0].controls.findIndex(md => md.subgrid);
        if (index >= 0) {
          //Add Tags at last field in contact fields
          contactForm.metadata[0].controls.splice(index, 0, new Control(TAG_LABEL_CONTROL));
        }
      }
      this.initBusinessRules(contactForm);
      this.dynamicFormType = formType;
      this.displayFormDetails = contactForm;
      this.rawFormData = this.contactService.contactInformation.raw;
      this.isSaveNotesEnabled = false;
      this.tempNoteText = '';
      this._cd.markForCheck();
      // Not awaited: the form renders from local storage first and the affiliations section
      // refills when the live list lands.
      this._loadAllAffiliatedAccounts();
      setTimeout(() => {
        this._initCustomerNotesViewData();
        this.initCustomerNotesData();
        this.initKOLStatusViewData();
        //this._initMedicalInsightsViewData();
        //this._initMedicalInsightsData();
      }, 100);
      const isContactfromContactToolEditable = this.isEditFeatureEnabled
        && ((!this.contactService.isInGlobalSearch || !this.contactService.isContactInGlobalSearch(this.contactService.contactInformation)) || this.businessLine === BusinessLineVal.PHARMA || this.businessLine === BusinessLineVal.RETAIL || this.businessLine === BusinessLineVal.VACCINE_MDM)
        && (this.contactService.contactPageMode === this.compViewMode.LISTVIEW || this.contactService.contactPageMode === this.compViewMode.ADDNEW)
        && !this.uiService.isConsentFromToolDrawer;
      if (this.contactService.contactPageMode === ComponentViewMode.PREVIEW || this.contactService.isContactInGlobalSearch(this.contactService.contactInformation)) {
        this.isPreViewMode = true;
        this.isEditable = false;
        this.isEditDisabled = true;
      } else {
        this.isPreViewMode = false;
        this.isEditable = isContactfromContactToolEditable;
        this.isEditDisabled = false;
      }
      // Mirrors the offline gate in initFeatureActions() - this refresh path recomputes
      // isEditable/isEditDisabled from scratch and would otherwise silently re-enable Edit
      // offline for the MDM/VEEVA/category-flow paths, which have no offline Change Request
      // submission support. Disables (greyed-out, not hidden) rather than hiding, matching
      // configured-account-info.ts's equivalent gate for the Account display form.
      if (this.device.isOffline && this.isEditable && this.contactService.contactInformation && (this.contactService.contactInformation.mdmType == MDMType.VEEVA || this.changeRequestCategoryFlowFeatureEnabled || this.mdmEditFeatureEnabled)) {
        this.isEditDisabled = true;
      }
      this.events.publish('refreshContactDetailPageTitle');
    }
  }

  private addLinkEntitiesForContact(linkEntity) {
    if (isEmpty(linkEntity))
      this.linkEntitiesReqPayload = [];
    else {
      const linkEntityPayload = {
        "values": linkEntity["values"],
        "entity": linkEntity["entity"],
        "linkedEntityId": linkEntity["linkedEntityExistingDataId"],
        "addedNewDataId": linkEntity["linkedEntityAddedNewDataId"]
      }
      if (!isEmpty(this.linkEntitiesReqPayload)) {
        let index;
          if (linkEntity["linkedEntityExistingDataId"]) {
            index = this.linkEntitiesReqPayload.findIndex(x => x.linkedEntityId == linkEntity["linkedEntityExistingDataId"]);
          } else {
            index = this.linkEntitiesReqPayload.findIndex(x => x.addedNewDataId == linkEntity["linkedEntityAddedNewDataId"]);
          }
          if (index != -1) {
            this.linkEntitiesReqPayload[index] = linkEntityPayload;
          } else this.linkEntitiesReqPayload.push(linkEntityPayload);
        } else {
          this.linkEntitiesReqPayload.push(linkEntityPayload);
        }
    }
  }

  private async initOKContactInfo() {
    if (this.contactService.selectedOKContact.value) {
      let contactForm: DynamicForm = await this.dynamicFormsService.getFormDefinitionForEntity("contact", FormType.DISPLAYFORM, BusinessProcessType.OneKey);
      let formType = DynamicFormType.CONFIGUREDFORM;
      if (!contactForm) {
        contactForm = new DynamicForm(DEFAULT_CONTACT_DISPLAY_FORM['value'][0]);
        formType = DynamicFormType.DEFAULTFORM;
      }
      this.initBusinessRules(contactForm);
      this.dynamicFormType = formType;
      this.displayFormDetails = contactForm;
      this.isEditable = false;
      this.rawFormData = this.rawOKContactObj;
      this.events.publish('refreshContactDetailPageTitle');
    }
  }

  get rawOKContactObj(): any {
    let contactObj = this.contactService.selectedOKContact.value;
    let rawContact = {
      "contactid": "",
      "firstname": contactObj['firstName'] ? contactObj['firstName'] : "",
      "indskr_title": contactObj['titleCode'] ? Number(contactObj['titleCode']) : 0,
      "title": contactObj['titleLabel'] ? contactObj['titleLabel'] : "",
      "indskr_title@OData.Community.Display.V1.FormattedValue": contactObj['titleCorporateLabel'] ? contactObj['titleCorporateLabel'] : "",
      "statuscode@OData.Community.Display.V1.FormattedValue": contactObj['statusCorporateLabel'],
      "statuscode": Number(contactObj['statusCode']),
      "fullname": this.contactService.getFullName(contactObj),
      "lastname": contactObj['lastName'] ? contactObj['lastName'] : "",
      "middlename": contactObj['middleName'] ? contactObj['middleName'] : '',
      "indskr_mdmid": contactObj['individualEid'],
      "indskr_contactsourcetype":ChangeRequestType.MDM,
      "indskr_contactsourcetype@OData.Community.Display.V1.FormattedValue":"MDM",
      "indskr_contactsourcetype_Formatted":"MDM",
      "indskr_mdm":MDMType.ONEKEY,
      "indskr_mdm@OData.Community.Display.V1.FormattedValue":"OneKey",
      "indskr_mdm_Formatted":"OneKey",
    };
    return rawContact;
  }

  private handleNoteAttachment(){
    if(this.isCustomerNotesAttachmentEnabled){
      try {
        this.attachInput.nativeElement.click();
      } catch (error) {
      }
    }
  }

  public removeAttachment(event){
    try {
      this.attachInput.nativeElement.value = null;
    } catch (error) {
    }
    this.attachmentTitle = '';
    this.isAttachmentAdded = false;
    this.attachmentFile = null;
    this.base64str = null;
    this._initCustomerNotesViewData();
  }

  public isNoteDeletable(note: IONote): boolean {
    return ((this.isCustomerNotesEnabled && this.isCustomerNotesAttachmentEnabled) || (this.isCustomerNotesEnabled && !note.hasDocument) || (this.isCustomerNotesAttachmentEnabled && isEmpty(note.noteText))) && isEqual(note.ownerId, this.authService.user.systemUserID);
  }

  public isNoteEditable(note: IONote): boolean {
    return (this.isCustomerNotesEnabled || this.isCustomerNotesAttachmentEnabled) && isEqual(note.ownerId, this.authService.user.systemUserID);
  }


  public async loadImageFromDevice(event) {
    if (event && event.target && event.target.files) {
      try {
        const file = event.target.files[0];
        if ((file.size / 1000) < MAXIMUM_NOTE_ATTACHMENT_SIZE) {
          if (NOTE_ATTACHMENT_MIME_TYPES_SUPPORTED_REGEX.test(file.name)) {
            this.base64str = await toBase64(file);
            const dataURLPattern = /^data:[^;]+;base64,/;
            this.base64str = this.base64str.replace(dataURLPattern, '');
            this.attachmentFile = file;
            this.attachmentTitle = file.name;
            this.isAttachmentAdded = true;
            this._initCustomerNotesViewData();
          } else {
            this.notificationService.notify(this.translate.instant('NOTE_ATTACHMENT_MIME_TYPE_NOT_SUPPORTED_NOTIFICATION'), 'Account Info', 'top', 'info');
            this.removeAttachment(false);
          }
        } else {
          this.notificationService.notify(this.translate.instant('MAXIMUM_NOTE_ATTACHMENT_SIZE_NOTIFICATION', { size: MAXIMUM_NOTE_ATTACHMENT_SIZE }), 'Account Info', 'top', 'info');
          this.removeAttachment(false);
        }
      } catch (error) {
      }
    }
  }

  public async handleSaveNote() {
    if (!isEmpty(this.tempNoteText) || this.isAttachmentAdded) {
      // this.uiService.displayLoader();

      const loader = await this.loadingCtrl.create();
      loader.present();

      this.isSaveNotesEnabled = false;
      const now = new Date().getTime().toString();
      const offlinePayload = {
        annotationid: 'offlinecustomernote' + now,
        contactid: this.contactService.contactInformation.ID,
        createdon: now,
        notetext: this.tempNoteText,
        ownerName: this.authService.user.displayName,
        ownerid: this.authService.user.systemUserID,
        deleted: false,
        pendingPushOnDynamics: true,
      };

      if (this.base64str) {
        offlinePayload['isdocument'] = true;
        offlinePayload['documentbody'] = this.base64str;
        offlinePayload['filename'] = this.attachmentFile.name;
        offlinePayload['filesize'] = this.attachmentFile.size;
        offlinePayload['mimetype'] = this.attachmentFile.type;
      }

      let currentNote = new IONote(offlinePayload);
      await this.contactDataService.updateCustomerNoteInOfflineDB(offlinePayload);
      if (!this.device.isOffline) {
        await this.contactDataService.uploadCustomerNotesOnline().then(res => {
          if (res && Array.isArray(res) && res.length > 0 && res[0].noteid) {
            currentNote.noteId = res[0].noteid;
          }
        });
      }
      // The upload's save may already have reloaded this note from disk.
      if (!this.currentCustomerNotes.some(note => note.noteId == currentNote.noteId)) {
        this.currentCustomerNotes.push(currentNote);
      }
      this._sortCustomerNotes();
      this.tempNoteText = '';
      this.removeAttachment(null);
      this.isSaveNotesEnabled = false;
      this._initCustomerNotesViewData();
      loader.dismiss();
    }
  }

  private _sortCustomerNotes(){
    if(this.currentCustomerNotes && this.currentCustomerNotes.length > 1){
      this.currentCustomerNotes = this.currentCustomerNotes.sort((a,b)=>{
        return (this.dateTimeFormatsService.isBeforeDate(a.createdTime, b.createdTime) ? 1 : -1);
      });
    }
  }
  private async _addOfflineLinkedEntityToDisk(linkedEntity){
    const linkedEntityDBPrefix = '';
    const selectedContact = this.contactService.contactInformation;
    let dbKey = linkedEntity.entity;

    let values = linkedEntity.values;

    if(linkedEntity.entity == 'indskr_email_addresses')
      dbKey = 'indskr_email_address';
    else if(linkedEntity.entity == 'indskr_accountcontactaffiliations') {
      dbKey = 'indskr_accountcontactaffiliation';
    }

    let rawLEData = await this.disk.retrieve(linkedEntityDBPrefix + dbKey);

    if(rawLEData && rawLEData.raw) {

        if(dbKey === 'indskr_email_address') {
          let existingLinkedEntity = rawLEData.raw.find(item => item['indskr_email_address.indskr_email_addressid'] === linkedEntity.linkedEntityId);
          let index = rawLEData.raw.indexOf(existingLinkedEntity);

          if(existingLinkedEntity) {

            for (const key in values) {
              let customKey = `${dbKey}.${key}`;

              if (existingLinkedEntity.hasOwnProperty(customKey)) {
                existingLinkedEntity[customKey] = values[key];
              }

              if(customKey === 'indskr_email_address.indskr_isprimary')
              {
                let value = values[key] === true ? 'Yes':'No' ;

                let newCustomKey = `${dbKey}.indskr_isprimary_Formatted`;

                if (existingLinkedEntity.hasOwnProperty(newCustomKey)) {
                  existingLinkedEntity[newCustomKey] = value;
                }

                newCustomKey = `${dbKey}.indskr_isprimary@OData.Community.Display.V1.FormattedValue`;

                if (existingLinkedEntity.hasOwnProperty(newCustomKey)) {
                  existingLinkedEntity[newCustomKey] = value;
                }
              }

              customKey = `contactid`;

              if (existingLinkedEntity.hasOwnProperty(customKey)) {
                existingLinkedEntity[customKey] = selectedContact.ID;
              }
            }

            rawLEData.raw[index] = existingLinkedEntity;
          }//end of if(existingLinkedEntity)
          else {
            let newLinkEntityData = Object.assign({}, rawLEData.raw[0]);

            for (const key in values) {
              let customKey = `${dbKey}.${key}`;

              if (newLinkEntityData.hasOwnProperty(customKey)) {
                newLinkEntityData[customKey] = values[key];
              }

              if(customKey === 'indskr_email_address.indskr_isprimary')
              {
                let value = values[key] === true ? 'Yes':'No' ;

                let newCustomKey = `${dbKey}.indskr_isprimary_Formatted`;

                if (newLinkEntityData.hasOwnProperty(newCustomKey)) {
                  newLinkEntityData[newCustomKey] = value;
                }

                newCustomKey = `${dbKey}.indskr_isprimary@OData.Community.Display.V1.FormattedValue`;

                if (newLinkEntityData.hasOwnProperty(newCustomKey)) {
                  newLinkEntityData[newCustomKey] = value;
                }
              }

              customKey = `contactid`;

              if (newLinkEntityData.hasOwnProperty(customKey)) {
                newLinkEntityData[customKey] = selectedContact.ID;
              }
            }

            rawLEData.raw.push(newLinkEntityData);
          }
        }//end of if(dbKey === 'indskr_email_address') {
        else if(dbKey === 'indskr_accountcontactaffiliation') {

          let existingLinkedEntity = rawLEData.raw.find(item => item['indskr_accountcontactaffiliation.indskr_accountcontactaffiliationid'] === linkedEntity.linkedEntityId);
          let index = rawLEData.raw.indexOf(existingLinkedEntity);

          if(existingLinkedEntity) {
            if(Object.keys(values).findIndex(key => key == 'statecode')>-1 && values['statecode'] == 1) {
              rawLEData.raw.splice(index,1);
            } else {
              for (const key in values) {
                if(key === 'lookupfields') {
                  const accounts = values[key].find(item => item['entity'] === 'accounts');
                  const omnione_lu_AffiliationRole = values[key].find(item => item['name'] === 'omnione_lu_AffiliationRole');
                  const affiliatedAccount = this.accountService.getAccountById(accounts['id']);

                  let customKey = `${dbKey}.indskr_accountid`;

                  existingLinkedEntity[customKey] = accounts['id'];

                  customKey = `${dbKey}.indskr_accountid@OData.Community.Display.V1.FormattedValue`;

                  existingLinkedEntity[customKey] = affiliatedAccount.accountName;

                  customKey = `${dbKey}.indskr_accountid_Formatted`;

                  existingLinkedEntity[customKey] = affiliatedAccount.accountName;

                  let value = values['indskr_isprimaryaccount'] === true ? 'Yes':'No' ;

                  let newCustomKey = `${dbKey}.indskr_isprimaryaccount`;

                  existingLinkedEntity[newCustomKey] = value;

                  newCustomKey = `${dbKey}.indskr_isprimaryaccount@OData.Community.Display.V1.FormattedValue`;

                  existingLinkedEntity[newCustomKey] = value;

                  customKey = `contactid`;

                  existingLinkedEntity[customKey] = selectedContact.ID;

                  if(omnione_lu_AffiliationRole) {
                    newCustomKey = `${dbKey}.omnione_lu_affiliationrole`;

                    existingLinkedEntity[newCustomKey] = omnione_lu_AffiliationRole['id'];

                    const selectedOmnione_lu_affiliationrole = this.dynamicFormsService.allLookUpFieldsForOfflineEdit['omnione_lu_affiliationrole'].find(item => item['id'] == omnione_lu_AffiliationRole['id']);

                    newCustomKey = `${dbKey}.omnione_lu_affiliationrole@OData.Community.Display.V1.FormattedValue`;

                    existingLinkedEntity[newCustomKey] = selectedOmnione_lu_affiliationrole['nameForSearch'];

                    newCustomKey = `${dbKey}.omnione_lu_affiliationrole_Formatted`;

                    existingLinkedEntity[newCustomKey] = selectedOmnione_lu_affiliationrole['nameForSearch'];
                  }

                }
                else if(key === 'indskr_isprimaryaccount') {
                  let newCustomKey = `${dbKey}.indskr_isprimaryaccount`;

                  existingLinkedEntity[newCustomKey] = values[key];

                  let value = values[key] === true ? 'Yes':'No' ;

                  newCustomKey = `${dbKey}.indskr_isprimaryaccount_Formatted`;

                  existingLinkedEntity[newCustomKey] = value;

                  newCustomKey = `${dbKey}.indskr_isprimaryaccount@OData.Community.Display.V1.FormattedValue`;

                  existingLinkedEntity[newCustomKey] = value;
                }
                else if(key === 'indskr_affiliationsourcetype') {
                  let newCustomKey = `${dbKey}.indskr_affiliationsourcetype`;

                  existingLinkedEntity[newCustomKey] = values[key];

                  let value = values[key] == '548910000' ? 'Business':'MDM' ;

                  newCustomKey = `${dbKey}.indskr_affiliationsourcetype_Formatted`;

                  existingLinkedEntity[newCustomKey] = value;

                  newCustomKey = `${dbKey}.indskr_affiliationsourcetype@OData.Community.Display.V1.FormattedValue`;

                  existingLinkedEntity[newCustomKey] = value;
               }
              }//end of for (const key in values)

              rawLEData.raw[index] = existingLinkedEntity;
            }
          }
          else {

            let newLinkEntityData = {
              "@odata.etag": "W/\"645798083\"",
              "contactid": "c27fbf73-8ba9-e911-a9a8-000d3a8210e3",
              "indskr_accountcontactaffiliation.indskr_affiliationsourcetype@OData.Community.Display.V1.AttributeName": "indskr_affiliationsourcetype",
              "indskr_accountcontactaffiliation.indskr_affiliationsourcetype@OData.Community.Display.V1.FormattedValue": "Business",
              "indskr_accountcontactaffiliation.indskr_affiliationsourcetype": 548910000,
              "indskr_accountcontactaffiliation.createdon@OData.Community.Display.V1.AttributeName": "createdon",
              "indskr_accountcontactaffiliation.createdon@OData.Community.Display.V1.FormattedValue": "06/18/2021 06:24 PM",
              "indskr_accountcontactaffiliation.createdon": "2021-06-18T12:54:23.000Z",
              "indskr_accountcontactaffiliation.statuscode@OData.Community.Display.V1.AttributeName": "statuscode",
              "indskr_accountcontactaffiliation.statuscode@OData.Community.Display.V1.FormattedValue": "Verified",
              "indskr_accountcontactaffiliation.statuscode": 1,
              "indskr_accountcontactaffiliation.statecode@OData.Community.Display.V1.AttributeName": "statecode",
              "indskr_accountcontactaffiliation.statecode@OData.Community.Display.V1.FormattedValue": "Active",
              "indskr_accountcontactaffiliation.statecode": 0,
              "indskr_accountcontactaffiliation.omnione_lu_affiliationrole@OData.Community.Display.V1.AttributeName": "omnione_lu_affiliationrole",
              "indskr_accountcontactaffiliation.omnione_lu_affiliationrole@OData.Community.Display.V1.FormattedValue": "Accounting and Finance",
              "indskr_accountcontactaffiliation.omnione_lu_affiliationrole@Microsoft.Dynamics.CRM.lookuplogicalname": "omnione_onekeycodeslabels",
              "indskr_accountcontactaffiliation.omnione_lu_affiliationrole": "ddb8df53-f0c9-ec11-a7b6-000d3a857cb6",
              "indskr_accountcontactaffiliation.indskr_isprimaryaccount@OData.Community.Display.V1.AttributeName": "indskr_isprimaryaccount",
              "indskr_accountcontactaffiliation.indskr_isprimaryaccount@OData.Community.Display.V1.FormattedValue": "No",
              "indskr_accountcontactaffiliation.indskr_isprimaryaccount": false,
              "indskr_accountcontactaffiliation.indskr_accountid@OData.Community.Display.V1.AttributeName": "indskr_accountid",
              "indskr_accountcontactaffiliation.indskr_accountid@OData.Community.Display.V1.FormattedValue": "0516_Leah Test AccountBān",
              "indskr_accountcontactaffiliation.indskr_accountid@Microsoft.Dynamics.CRM.lookuplogicalname": "account",
              "indskr_accountcontactaffiliation.indskr_accountid": "0a79759e-95b7-eb11-8236-002248173c8c",
              "indskr_accountcontactaffiliation.indskr_accountcontactaffiliationid@OData.Community.Display.V1.AttributeName": "indskr_accountcontactaffiliationid",
              "indskr_accountcontactaffiliation.indskr_accountcontactaffiliationid": "e5bc644b-34d0-eb11-bacc-00224816cd59",
              "indskr_accountcontactaffiliation.indskr_affiliationsourcetype_Formatted": "Business",
              "indskr_accountcontactaffiliation.createdon_Formatted": "06/18/2021 06:24 PM",
              "indskr_accountcontactaffiliation.statuscode_Formatted": "Verified",
              "indskr_accountcontactaffiliation.statecode_Formatted": "Active",
              "indskr_accountcontactaffiliation.omnione_lu_affiliationrole_Formatted": "Accounting and Finance",
              "indskr_accountcontactaffiliation.omnione_lu_affiliationrole_LogicalName": "omnione_onekeycodeslabels",
              "indskr_accountcontactaffiliation.indskr_isprimaryaccount_Formatted": "No",
              "indskr_accountcontactaffiliation.indskr_accountid_Formatted": "0516_Leah Test AccountBān",
              "indskr_accountcontactaffiliation.indskr_accountid_LogicalName": "account"
            }

            for (const key in values) {
              if(key === 'lookupfields') {
                const accounts = values[key].find(item => item['entity'] === 'accounts');
                const omnione_lu_AffiliationRole = values[key].find(item => item['name'] === 'omnione_lu_AffiliationRole');
                const affiliatedAccount = this.accountService.getAccountById(accounts['id']);

                let customKey = `${dbKey}.indskr_accountid`;

                newLinkEntityData[customKey] = accounts['id'];

                customKey = `${dbKey}.indskr_accountid@OData.Community.Display.V1.FormattedValue`;

                newLinkEntityData[customKey] = affiliatedAccount.accountName;

                customKey = `${dbKey}.indskr_accountid_Formatted`;

                newLinkEntityData[customKey] = affiliatedAccount.accountName;

                let value = values['indskr_isprimaryaccount'] === true ? 'Yes':'No' ;

                let newCustomKey = `${dbKey}.indskr_isprimaryaccount`;

                newLinkEntityData[newCustomKey] = value;

                newCustomKey = `${dbKey}.indskr_isprimaryaccount@OData.Community.Display.V1.FormattedValue`;

                newLinkEntityData[newCustomKey] = value;

                customKey = `contactid`;

                newLinkEntityData[customKey] = selectedContact.ID;

                if(omnione_lu_AffiliationRole) {
                  newCustomKey = `${dbKey}.omnione_lu_affiliationrole`;

                  newLinkEntityData[newCustomKey] = omnione_lu_AffiliationRole['id'];

                  const selectedOmnione_lu_affiliationrole = this.dynamicFormsService.allLookUpFieldsForOfflineEdit['omnione_lu_affiliationrole'].find(item => item['id'] == omnione_lu_AffiliationRole['id']);

                  newCustomKey = `${dbKey}.omnione_lu_affiliationrole@OData.Community.Display.V1.FormattedValue`;

                  newLinkEntityData[newCustomKey] = selectedOmnione_lu_affiliationrole['nameForSearch'];

                  newCustomKey = `${dbKey}.omnione_lu_affiliationrole_Formatted`;

                  newLinkEntityData[newCustomKey] = selectedOmnione_lu_affiliationrole['nameForSearch'];
                }

              }
              else if(key === 'indskr_isprimaryaccount') {
                let newCustomKey = `${dbKey}.indskr_isprimaryaccount`;

                newLinkEntityData[newCustomKey] = values[key];

                let value = values[key] === true ? 'Yes':'No' ;

                newCustomKey = `${dbKey}.indskr_isprimaryaccount_Formatted`;

                newLinkEntityData[newCustomKey] = value;

                newCustomKey = `${dbKey}.indskr_isprimaryaccount@OData.Community.Display.V1.FormattedValue`;

                newLinkEntityData[newCustomKey] = value;
              }
              else if(key === 'indskr_affiliationsourcetype') {
                let newCustomKey = `${dbKey}.indskr_affiliationsourcetype`;

                newLinkEntityData[newCustomKey] = values[key];

                let value = values[key] == '548910000' ? 'Business':'MDM' ;

                newCustomKey = `${dbKey}.indskr_affiliationsourcetype_Formatted`;

                newLinkEntityData[newCustomKey] = value;

                newCustomKey = `${dbKey}.indskr_affiliationsourcetype@OData.Community.Display.V1.FormattedValue`;

                newLinkEntityData[newCustomKey] = value;
              }
            }//end of for (const key in values)

            rawLEData.raw.push(newLinkEntityData);
          }
        }//end of if(dbKey === 'indskr_accountcontactaffiliation')

        await this.disk.updateOrInsert(linkedEntityDBPrefix + dbKey, (doc)=>rawLEData)
          .catch(error => console.error('addOfflineLinkedEntityToDisk: ', error))
    }
  }

  public getKOLViewModel(field, kol: KOLStatus): IndFormFieldViewDataModel {
    switch (field) {
      case 'disease_area':
        return {
          label: this.translate.instant('DISEASE_AREA'),
          inputText: kol.diseaseAreaName,
          customCssClass: 'kol-status-item',
          id: 'disease-area-field',
          isReadOnly: true,
          isDisabled: true,
        };
      case 'kol_type':
        return {
          label: this.translate.instant('KOL_TYPE'),
          inputText: kol.kolTypeString,
          customCssClass: 'kol-status-item',
          id: 'kol-type-field',
          isReadOnly: true,
          isDisabled: true,
        };
      case 'status':
        return {
          label: this.translate.instant('STATUS'),
          inputText: kol.statusString,
          customCssClass: 'kol-status-item',
          id: 'status-field',
          isReadOnly: true,
          isDisabled: true,
        };
      case 'date':
        return {
          label: this.translate.instant('DATE'),
          inputText: this.datePipe.transform(kol.createdOn, this.dateTimeFormatsService.date, undefined, this.translate.currentLang),
          customCssClass: 'kol-status-item',
          id: 'date-field',
          isReadOnly: true,
          isDisabled: true,
        };
      case 'owner':
        return {
          label: this.translate.instant('OM_OWNER'),
          inputText: kol.ownerName,
          customCssClass: 'kol-status-item',
          id: 'owner-field',
          isReadOnly: true,
          isDisabled: true,
        };
    }
  }

  private async _handleEmailCRFormComponentEvent(data, eventTarget, refData:DynamicFormComponentModel){
      if(eventTarget) {
        if (eventTarget == 'DONEBUTTONCLICK') {
          if (data && data.formValue) {
            await this.uiService.displayLoader();
            let payload = cloneDeep(data.formValue);

            const selectedContact = this.contactService.contactInformation;
            if (selectedContact) {
              payload = {
                'indskr_firstname': selectedContact.firstName || '',
                'indskr_lastname': selectedContact.lastName || '',
                ...payload
              }
              payload['indskr_Contact@odata.bind'] = `/contacts(${selectedContact.ID})`;
            }

            if (payload['contactid']) {
              delete payload['contactid'];
            }

            payload["linkEntities"] = this.mdmService.getReqPayloadLinkEntities();
            payload['statecode'] = ChangeRequestStateCode.ACTIVE;

            if (!this.device.isOffline) {
              if (payload["linkEntities"] && payload["linkEntities"].length > 0) {
                payload["linkEntities"].forEach(le => {
                  le['values'].forEach(value => {
                    if (value['guid']) {
                      value['indskr_EmailAddressReference@odata.bind'] = `/indskr_emailaddresscrs(${value['guid']})`;
                      delete value['guid'];
                    }
                  });
                });
              }

              await this.mdmService.createBusinessContactDataCR(payload).then(async (res: any) => {
                data.eventsHandler(res, 'DISABLEFORM');

                // Create the Notifiction here on Business contact submission.
                let fullNameStr: string = '';
                const selectedContact = this.contactService.contactInformation;
                if (selectedContact) {
                  if (selectedContact.fullname) {
                    fullNameStr = selectedContact.fullname;
                  } else if (selectedContact.firstName && selectedContact.lastName) {
                    fullNameStr = selectedContact.firstName + ' ' + selectedContact.lastName;
                  } else if (selectedContact.firstName && !selectedContact.lastName) {
                    fullNameStr = selectedContact.firstName;
                  } else if (!selectedContact.firstName && selectedContact.lastName) {
                    fullNameStr = selectedContact.lastName;
                  }
                }
                await this.mdmService.addNotification(data, res, NOTIFICATION.BUSINESS_CHANGE_REQUEST_OPEN, this.translate.instant('BUSINESS_CHANGE_REQUEST_SUBMITTED', { fullname: fullNameStr}), 'Open', fullNameStr);
                await this.myAssistantService.loadAndMapNotificationsFromDB();

                this.dynamicFormsService.linkedEntityFormIsDirtyTracker = false;
                this.notificationService.notify(this.translate.instant('BUSINESS_CHANGE_REQUEST_CREATE_CONTACT_SUCCESSFULL'), 'DynamicFormComponent', "top", ToastStyle.INFO, 3000);
                await this.uiService.dismissLoader();

              }).catch((err) => {
                this.uiService.dismissLoader();
              });
            } else {
              //offline mode
              const emailAddressId = payload["linkEntities"][0]['values'][0]['guid'] || '';
              const addedNewBusinessCRId = 'businesscr' + '_' + 'emailcr' + '_' +  emailAddressId;

              if (this.contactDataService.isOfflineBusinessCR(addedNewBusinessCRId)) {
                payload['indskr_contactsourcetype'] = BusinessProcessType.Omnipresence;
                payload['addedNewOneKeyCRId'] = addedNewBusinessCRId;
                payload['indskr_contactcrid'] = addedNewBusinessCRId;

                this.contactDataService.addToOfflineBusinessCRIds(payload.addedNewBusinessCRId);

                if (selectedContact) {
                  payload['indskr_Contact@odata.bind'] = `/contacts(${selectedContact.ID})`;
                }

                if (payload['contactid']) {
                  delete payload['contactid'];
                }

                if (payload["linkEntities"] && payload["linkEntities"].length > 0) {
                  payload["linkEntities"].forEach(le => {
                    le['values'].forEach(value => {
                      if (value['guid']) {
                        value['indskr_EmailAddressReference@odata.bind'] = `/indskr_emailaddresscrs(${value['guid']})`;
                        delete value['guid'];
                      }
                    });
                  });
                }

                await this.disk.createOfflineBusinessCRWithEmailCR(payload);

                //update contact cr db
                payload['modifiedon'] = new Date().getTime();
                payload['createdon'] = new Date().getTime();

                await this.mdmService.upsertContactCRInPouchDB(payload);

                //update contact cr list
                let contactCRs = this.mdmService.contactCRs.getValue();
                const crIdx = contactCRs.findIndex(cr => cr['addedNewOneKeyCRId'] == addedNewBusinessCRId);
                if (crIdx > -1) {
                  contactCRs[crIdx] = payload;
                } else {
                  contactCRs.push(payload);
                }
                this.mdmService.contactCRs.next(contactCRs);
                this.mdmService.contactCRList = contactCRs;

                //update form and notification
                const resok = {
                  "indskr_contactcrid": payload['indskr_contactcrid']
                };
                data.eventsHandler(resok, 'DISABLEFORM');
                this.dynamicFormsService.linkedEntityFormIsDirtyTracker = false;
                this.notificationService.notify(this.translate.instant('BUSINESS_CHANGE_REQUEST_CREATE_CONTACT_SUCCESSFULL'), 'DynamicFormComponent', "top", ToastStyle.INFO, 3000);
                await this.uiService.dismissLoader();

              }
            }
          }
        } else if(eventTarget == 'CANCELBUTTONCLICK') {
          this.closePage();
        } else if(eventTarget == 'ADDEDLINKEDENTITY') {
          if (data) {
            this.mdmService.editEmailAddressCRLinkEntities(data);
            this.dynamicFormsService.linkedEntityFormIsDirtyTracker = true;
            if (data && data.eventsHandler) {
              data.eventsHandler(data, 'ENABLEFORM');
            }
          }
        } else if (eventTarget == 'ISFORMDIRTY') {

        }
      }
    }

}
